import React, { useEffect, useState } from 'react';
import { useGLTF, Text, Line, Cone } from '@react-three/drei';
import { useParams } from 'react-router-dom';

function EasyAlu(props) {
  let picketarr = [];
  let para = useParams();
  let textscale = [1, 1, 1];
  let textup = -0.5;
  let triggerbit = 0;
  let triggerbit2 = 0;
  let triggerbit3 = 0;
  let adjustheighttext = 0;
  let [bevelhandlauf, setbevelhandlauf] = useState(false);
  let [straighthandlauf, setstraighthandlauf] = useState(true);
  let [topmount, settopmount] = useState(false);
  let [facial, setfacial] = useState(true);
  let [colorr, setcolorr] = useState();
  let [ugcol, setugcol] = useState();
  let [gesamtpos, setgesamtpos] = useState(0);
  let [gescount, setgescount] = useState(0);
  let muricaheight = 0;
  let lastadjust = 0;
  useEffect(() => {
    if (props.montageart == 'top') {
      settopmount(true);
      setfacial(false);
    } else {
      settopmount(false);
      setfacial(true);
    }
  }, [props.montageart]);

  useEffect(() => {
    if (props.form == 'i' && props.selectstep > 2 && props.len1 > 2200) {
      setgesamtpos(8);
      setgescount(1);
    }
    if (props.form == 'i' && props.selectstep > 2 && props.len1 > 3200) {
      setgesamtpos(15);
      setgescount(1);
    }
    if (props.form == 'i' && props.selectstep > 2 && props.len1 > 4200) {
      setgesamtpos(18);
      setgescount(1);
    }
    if (props.form == 'i' && props.selectstep > 2 && props.len1 > 5200) {
      setgesamtpos(23);
      setgescount(1);
    }
    if (props.form != 'i' && gescount == 1) {
      setgescount(0);
      setgesamtpos(0);
    }

    //        setcoords(props.coords)
  }, [props.coords, props.form, props.substep, props.len1, props.selectstep]);

  useEffect(() => {
    if (props.handlaufmat == 'straight') {
      setstraighthandlauf(true);
      setbevelhandlauf(false);
    }
    if (props.handlaufmat == 'bevel') {
      setstraighthandlauf(false);
      setbevelhandlauf(true);
    }
  }, [props.handlaufmat]);

  useEffect(() => {
    if (props.colorr == 'black') {
      setcolorr('black');
    }
    if (props.colorr == 'anrtz') {
      setcolorr('#293133');
    }
    if (props.colorr == 'gray') {
      setcolorr('gray');
    }
    if (props.colorr == 'brano') {
      setcolorr('#666');
    }
  }, [props.colorr]);

  useEffect(() => {
    if (props.untergrund == 'holz') {
      setugcol('#6d3d2d');
    }
    if (props.untergrund == 'metall') {
      setugcol('#C0C0C0');
    }
    if (props.untergrund == 'beton') {
      setugcol('white');
    }
  }, [props.untergrund]);

  function wallrender(measureadjust, step, lastadjust) {
    let topmountadjuster = 0;
    let topmountscalor = 0;

    if (topmount) {
      topmountadjuster = -0.52;
      topmountscalor = -0.3;
    }
    if (step == 1) {
      return (
        <mesh
          position={[
            2.6 + topmountadjuster,
            6.5,
            pointies[pointies.length - 1][1] + measureadjust - 0.15 - 0.4 + 0.56 - 0.08,
          ]}
          visible={props.wall1}
          material={materials['physi concrete']}
        >
          <boxGeometry args={[3.8 + topmountscalor, 13, 2]} />
          <meshStandardMaterial color={'#333'} />
        </mesh>
      );
    }
    if (step == 2) {
      return (
        <mesh
          position={[
            pointies2[pointies2.length - 1][1] + lastadjust + 0.285 - 0.72 - 0.6 - topmountadjuster,
            6.5,
            pointies3[pointies3.length - 1][1] + measureadjust - 0.198 + 0.2,
          ]}
          visible={props.wall2}
          material={materials['physi concrete']}
        >
          <boxGeometry args={[3.9 + topmountscalor, 13, 2]} />
          <meshStandardMaterial color={'#333'} />
        </mesh>
      );
    }

    if (step == 3) {
      return (
        <mesh
          position={[
            pointies2[pointies2.length - 1][1] + measureadjust + 0.285 + 0.7,
            6.5,
            1 + measureadjust - 0.198 + 0.2 - 1.83 + topmountadjuster,
          ]}
          visible={props.wall2}
          material={materials['physi concrete']}
        >
          <boxGeometry args={[2, 13, 3.9 + topmountscalor]} />
          <meshStandardMaterial color={'#333'} />
        </mesh>
      );
    }

    if (step == 4) {
      return (
        <mesh
          position={[2.62 + topmountadjuster, 6.5, 1 + measureadjust - 0.198 + 0.2 - 3.15 - 0.14]}
          visible={props.wall2}
          material={materials['physi concrete']}
        >
          <boxGeometry args={[3.8 + topmountscalor, 13, 2]} />
          <meshStandardMaterial color={'#333'} />
        </mesh>
      );
    }
  }

  function klammerrender(nbr) {
    let heightmove = 0;
    if (props.hohe == 900) {
      heightmove = -10;
    }
    if (props.hohe == 1000) {
      heightmove = -5;
    }
    if (props.hohe == 1100) {
      heightmove = 0;
    }
    if (nbr == 1) {
      if (props.len1 > 5000 && triggerbit == 0) {
        triggerbit = triggerbit + 1;

        let adjustbit = 0;
        let posi1 = 0;
        let posi2 = 0;
        if (props.len1 > 5000 && props.len1 < 10000) {
          posi1 = props.len1 / 20;
        }
        if (props.len1 > 10000) {
          posi1 = (props.len1 * 1) / 30;
          posi2 = (props.len1 * 2) / 30 + 4;
        }
        if (singlelength < 10.4) {
          adjustbit = 5;
        }
        if (singlelength <= 10.6) {
          adjustbit = 3;
        }
        if (singlelength >= 11.3) {
          adjustbit = -3;
        }
        if (singlelength > 11.5) {
          adjustbit = -5;
        }
        return (
          <>
            {straighthandlauf && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_normal_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 + adjustbit + posi1, 0 + heightmove, 0]}
              />
            )}
            {bevelhandlauf && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_bevel_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 + adjustbit + posi1, 0 + heightmove, 0]}
              />
            )}
            {straighthandlauf && posi2 > 0 && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_normal_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 + adjustbit + posi2, 0 + heightmove, 0]}
              />
            )}
            {bevelhandlauf && posi2 > 0 && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_bevel_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 + adjustbit + posi2, 0 + heightmove, 0]}
              />
            )}
          </>
        );
      }
    }
    if (nbr == 2) {
      if (props.len2 > 5000 && triggerbit2 == 0) {
        triggerbit2 = triggerbit2 + 1;
        let posi1 = 0;
        let posi2 = 0;
        if (props.len2 > 5000 && props.len2 < 10000) {
          posi1 = props.len2 / 20;
          posi1 = posi1 - singlelength2 * 10;
        }
        if (props.len2 > 10000) {
          posi1 = (props.len2 * 1) / 30;
          posi2 = (props.len2 * 2) / 30 + 4;

          posi1 = posi1 - singlelength2 * 10;
          posi2 = posi2 - singlelength2 * 10;
        }
        return (
          <>
            {straighthandlauf && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_normal_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 - posi1, 0 + heightmove, 0]}
              />
            )}
            {bevelhandlauf && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_bevel_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 - posi1, 0 + heightmove, 0]}
              />
            )}
            {straighthandlauf && posi2 > 0 && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_normal_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 - posi2, 0 + heightmove, 0]}
              />
            )}
            {bevelhandlauf && posi2 > 0 && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_bevel_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 - posi2, 0 + heightmove, 0]}
              />
            )}
          </>
        );
      }
    }

    if (nbr == 3) {
      if (props.len3 > 5000 && triggerbit3 == 0) {
        triggerbit3 = triggerbit3 + 1;
        let posi1 = 0;
        let posi2 = 0;
        if (props.len3 > 5000 && props.len3 < 10000) {
          posi1 = props.len3 / 20;
          posi1 = posi1 - singlelength3 * 10;
        }
        if (props.len3 > 10000) {
          posi1 = (props.len3 * 1) / 30;
          posi2 = (props.len3 * 2) / 30 + 4;

          posi1 = posi1 - singlelength3 * 10;
          posi2 = posi2 - singlelength3 * 10;
        }
        return (
          <>
            {straighthandlauf && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_normal_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 - posi1, 0 + heightmove, 0]}
              />
            )}
            {bevelhandlauf && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_bevel_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 - posi1, 0 + heightmove, 0]}
              />
            )}
            {straighthandlauf && posi2 > 0 && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_normal_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 - posi2, 0 + heightmove, 0]}
              />
            )}
            {bevelhandlauf && posi2 > 0 && (
              <mesh
                visible={true}
                geometry={nodes.Handrail_Connector_bevel_R.geometry}
                material={materials['physi alu']}
                position={[-56.02 - posi2, 0 + heightmove, 0]}
              />
            )}
          </>
        );
      }
    }
  }

  function picketadd(scaler, leng) {
    let propss = 1;
    if (propss == 1) {
      let lenny = parseInt(leng);
      let distance = leng * 10;
      picketarr = [];
      let range = distance / 2;

      let outer = 0 * scaler;
      let heightscaler = 1;
      let heightmove = 0;

      if (props.hohe == 900) {
        heightscaler = 100 / 110;
        heightmove = -5;
        muricaheight = 36;
      }
      if (props.hohe == 1000) {
        heightscaler = 105 / 110;
        heightmove = -2.5;
        muricaheight = 42;
      }
      if (props.hohe == 1100) {
        heightscaler = 1;
        heightmove = 0;
        muricaheight = 48;
      }

      range = (107.41 * scaler) / lenny;

      for (let i = 0; i < lenny + 1; i++) {
        picketarr.push(outer + range * (i - 1) + 0.1 * i);
      }
      if (props.len1 > 4500 || props.len2 > 4500 || props.len3 > 4500) {
        textscale = [1.2, 1.2, 1.2];
        textup = -0.75;
        adjustheighttext = 0.25;
      }
      if (props.len1 > 7000 || props.len2 > 7000 || props.len3 > 7000) {
        textscale = [1.5, 1.5, 1.5];
        textup = -0.75;
        adjustheighttext = 0.35;
      }
      if (props.len1 > 13000 || props.len2 > 13000 || props.len3 > 13000) {
        textscale = [2, 2, 2];
        textup = -0.75;
        adjustheighttext = 0.45;
      }
      if (props.len1 > 15500 || props.len2 > 15500 || props.len3 > 15500) {
        textscale = [3, 3, 3];
        textup = -0.75;
      }
      return (
        <>
          {picketarr.map((item, index) => {
            if (index > 0 && index < picketarr.length - 1) {
              return (
                <mesh
                  geometry={nodes.Easy_Alu_Picket_PRIM_0.geometry}
                  material={materials['physi alu']}
                  position={[0, 0 + heightmove, item]}
                  scale={[1, heightscaler, 1]}
                />
              );
            }
          })}
        </>
      );
    }
  }

  const { nodes, materials } = useGLTF('/EasyAluPicketLive.gltf');

  let length2 = parseInt(props.len2 / 10);
  let length1 = parseInt(props.len1 / 10);
  let length3 = parseInt(props.len3 / 10);
  let amount = parseInt(length1) / 120.0000001;
  let amount2 = parseInt(length2) / 120.0000001;
  let amount3 = parseInt(length3) / 120.0000001;

  amount = parseInt(amount);
  amount2 = parseInt(amount2);
  amount3 = parseInt(amount3);
  amount = amount + 1;
  amount2 = amount2 + 1;
  amount3 = amount3 + 1;

  let singlelength = length1 / amount;
  let singlelength2 = length2 / amount2;
  let singlelength3 = length3 / amount3;

  singlelength2 = singlelength2 / 10;
  singlelength3 = singlelength3 / 10;
  singlelength = singlelength / 10;
  let pointies = [];
  let pointies2 = [];
  let pointies3 = [];
  let adjuster = 0;
  if (props.len1 > 2000 && props.form == 'i') {
    adjuster = 6;
  }
  if (props.len1 > 3000 || props.len3 > 3000) {
    adjuster = 9;
  }
  if (props.len1 > 4000 || props.len3 > 4000) {
    adjuster = 15;
  }
  if (props.len1 > 5000 || props.len3 > 5000) {
    adjuster = 20;
  }
  if (props.len1 > 7000 || props.len3 > 7000) {
    adjuster = 25;
  }
  if (props.len1 > 9000 || props.len3 > 9000) {
    adjuster = 35;
  }
  if (props.len1 > 11000 || props.len3 > 11000) {
    adjuster = 45;
  }
  if (props.len1 > 12000 || props.len3 > 12000) {
    adjuster = 55;
  }
  if (props.len1 > 13000 || props.len3 > 13000) {
    adjuster = 58;
  }
  if (props.len1 > 14000 || props.len3 > 14000) {
    adjuster = 65;
  }
  //pointies.push([0,0,singlelength])
  for (let i = 0; i <= amount; i++) {
    pointies.push([0, singlelength * i]);
  }
  for (let i = 0; i <= amount2; i++) {
    pointies2.push([0, singlelength2 * i]);
  }
  for (let i = 0; i <= amount3; i++) {
    pointies3.push([length2 / 10, singlelength3 * i]);
  }

  let groupadjustx = 0.5;
  let groupadjusty = -1;

  return (
    <>
      <group position={[-1, 0, -0.7 - gesamtpos - 5 - adjuster]}>
        {pointies.map((item, index) => {
          let angle = Math.PI;
          if (index < pointies.length - 1) {
            let currentCoord = item;
            let nextCoord = pointies[index + 1];
            let scaler = singlelength / 11;

            let midpoint = [(currentCoord[0] + nextCoord[0]) / 2, (currentCoord[1] + nextCoord[1]) / 2];

            let lengthy2 = singlelength * 10;
            let handscalex = 1;
            let handscaley = scaler;
            let picketadjust = 0;
            let feet1adjust = 0;
            let feet2adjust = 0;
            let topadjust = 0;
            let botadjust = 0;
            let cornerposx = 0;
            let cornerposy = 0;
            let facialmeasureadjust = 0;
            lengthy2 = Math.round(lengthy2);
            let facialadjust1x = 5;
            let facialadjust2x;
            let initializator = 1;
            let heightscaler = 1;
            let heightmove = 0;
            let heightset = 0;
            if (props.hohe == 900) {
              heightscaler = 100 / 110;
              heightmove = -10;
              heightset = -1.015;
              muricaheight = 36;
            }
            if (props.hohe == 1000) {
              heightscaler = 105 / 110;
              heightmove = -5;
              heightset = -0.51;
              muricaheight = 42;
            }
            if (props.hohe == 1100) {
              heightscaler = 1;
              heightmove = 0;
              muricaheight = 48;
            }

            let floorscale = scaler;
            let floorpos = -5;
            let facialplate1 = false;
            let completeadjustx = 1.45;
            let completeadjusty = -0.17;
            let firstadjust = 0;
            let measureadjust = 0;
            let initialcorner = false;
            let generalcorner = true;
            let topperadjust = 0;
            let divy = Math.abs(50 - lengthy2);
            topperadjust = -25.9 + (3 / 7) * divy;
            measureadjust = 1.135;
            if (props.form == 'u' || props.form == 'l') {
              initialcorner = true;

              if (index == 0) {
                generalcorner = false;
              }
            }
            if (!topmount) {
              facialmeasureadjust = 0;
            }

            if (index == 0) {
              facialplate1 = true;
              firstadjust = 0.37;
            }

            if (initializator == 1) {
              if (lengthy2 >= 50 && lengthy2 < 51) {
                feet1adjust = 3;
                feet2adjust = 6.5;
                picketadjust = -24.5;
                botadjust = -5;
                topadjust = -4.7;
                cornerposy = -33.7;
                facialadjust1x = -34.1;
                facialadjust2x = -24.6;
                floorpos = -5;
                firstadjust = 0.3125;
                completeadjustx = 1.53;
                measureadjust = 1.265;
                topperadjust = -25.9;
              }
              if (lengthy2 >= 51 && lengthy2 < 52) {
                feet1adjust = 3;
                feet2adjust = 6.4;
                picketadjust = -24.3;
                botadjust = -5;
                topadjust = -4.7;
                cornerposy = -33.2;
                facialadjust1x = -33.5;
                facialadjust2x = -24.3;
                floorpos = -5;
                firstadjust = 0.3125;
                completeadjustx = 1.53;
                measureadjust = 1.265;
              }
              if (lengthy2 >= 52 && lengthy2 < 53) {
                feet1adjust = 3;
                feet2adjust = 6.35;
                picketadjust = -24.1;
                botadjust = -5;
                topadjust = -4.7;
                cornerposy = -32.7;
                facialadjust1x = -33;
                facialadjust2x = -23.8;
                floorpos = -4.75;
                firstadjust = 0.3085;
                completeadjustx = 1.53;
                measureadjust = 1.245;
              }
              if (lengthy2 >= 53 && lengthy2 < 54) {
                feet1adjust = 3.1;
                feet2adjust = 6.2;
                picketadjust = -24.1;
                botadjust = -5;
                topadjust = -4.5;
                cornerposy = -32.2;
                facialadjust1x = -32.3;
                facialadjust2x = -23.3;
                floorpos = -4.7;
                firstadjust = 0.3075;
                completeadjustx = 1.53;
                measureadjust = 1.235;
              }
              if (lengthy2 >= 54 && lengthy2 < 55) {
                feet1adjust = 3.2;
                feet2adjust = 6.1;
                picketadjust = -23.8;
                botadjust = -5;
                topadjust = -4.4;
                cornerposy = -31.7;
                facialadjust1x = -31.5;
                facialadjust2x = -23;
                floorpos = -4.65;
                firstadjust = 0.306;
                completeadjustx = 1.53;
                completeadjusty = -0.16;
                measureadjust = 1.235;
              }
              if (lengthy2 >= 55 && lengthy2 < 56) {
                feet1adjust = 3.2;
                feet2adjust = 6;
                picketadjust = -23.2;
                botadjust = -5;
                topadjust = -4.4;
                cornerposy = -31.2;
                facialadjust1x = -31;
                facialadjust2x = -22.6;
                floorpos = -4.6;
                firstadjust = 0.3045;
                completeadjustx = 1.52;
                completeadjusty = -0.16;
                measureadjust = 1.225;
              }
              if (lengthy2 >= 56 && lengthy2 < 57) {
                feet1adjust = 3.25;
                feet2adjust = 5.8;
                picketadjust = -23;
                botadjust = -5;
                topadjust = -4.3;
                cornerposy = -30.7;
                facialadjust1x = -30.6;
                facialadjust2x = -22;
                floorpos = -4.5;
                firstadjust = 0.301;
                completeadjustx = 1.51;
                completeadjusty = -0.16;
                measureadjust = 1.215;
              }
              if (lengthy2 >= 57 && lengthy2 < 58) {
                feet1adjust = 3.3;
                feet2adjust = 5.7;
                picketadjust = -22.9;
                botadjust = -5.1;
                topadjust = -4.2;
                cornerposy = -30.2;
                facialadjust1x = -30.1;
                facialadjust2x = -21.6;
                floorpos = -4.5;
                firstadjust = 0.2995;
                completeadjustx = 1.51;
                completeadjusty = -0.16;
                measureadjust = 1.205;
              }
              if (lengthy2 >= 58 && lengthy2 < 59) {
                feet1adjust = 3.35;
                feet2adjust = 5.5;
                picketadjust = -22.1;
                botadjust = -5.1;
                topadjust = -4.1;
                cornerposy = -29.7;
                facialadjust1x = -29.6;
                facialadjust2x = -21.2;
                floorpos = -4.45;
                firstadjust = 0.298;
                completeadjustx = 1.51;
                completeadjusty = -0.16;
                measureadjust = 1.199;
              }
              if (lengthy2 >= 59 && lengthy2 < 60) {
                feet1adjust = 3.2;
                feet2adjust = 5.4;
                picketadjust = -21.8;
                botadjust = -5.1;
                topadjust = -4;
                cornerposy = -29.2;
                facialadjust1x = -29;
                facialadjust2x = -20.9;
                floorpos = -4.4;
                firstadjust = 0.298;
                completeadjustx = 1.52;
                completeadjusty = -0.16;
                measureadjust = 1.189;
              }
              if (lengthy2 >= 60 && lengthy2 < 61) {
                feet1adjust = 3.1;
                feet2adjust = 5.2;
                picketadjust = -20.5;
                botadjust = -5.1;
                topadjust = -4;
                cornerposy = -28.7;
                facialadjust1x = -28.5;
                facialadjust2x = -20.3;
                floorpos = -4.35;
                firstadjust = 0.2985;
                completeadjustx = 1.53;
                completeadjusty = -0.16;
                measureadjust = 1.18;
              }
              if (lengthy2 >= 61 && lengthy2 < 62) {
                feet1adjust = 3.0;
                feet2adjust = 5.1;
                picketadjust = -20.3;
                botadjust = -5;
                topadjust = -3.95;
                cornerposy = -28.2;
                facialadjust1x = -28;
                facialadjust2x = -20.1;
                floorpos = -4.2;
                firstadjust = 0.2975;
                completeadjustx = 1.54;
                completeadjusty = -0.16;
                measureadjust = 1.18;
              }
              if (lengthy2 >= 62 && lengthy2 < 63) {
                feet1adjust = 2.9;
                feet2adjust = 5;
                picketadjust = -20.1;
                botadjust = -5;
                topadjust = -3.9;
                cornerposy = -27.7;
                facialadjust1x = -27.5;
                facialadjust2x = -19.7;
                floorpos = -4.1;
                firstadjust = 0.2975;
                completeadjustx = 1.55;
                completeadjusty = -0.16;
                measureadjust = 1.175;
              }
              if (lengthy2 >= 63 && lengthy2 < 64) {
                feet1adjust = 2.8;
                feet2adjust = 4.9;
                picketadjust = -19.9;
                botadjust = -5;
                topadjust = -3.8;
                cornerposy = -27.2;
                facialadjust1x = -26.8;
                facialadjust2x = -19.4;
                floorpos = -4.0;
                firstadjust = 0.2975;
                completeadjustx = 1.56;
                completeadjusty = -0.16;
                measureadjust = 1.165;
              }
              if (lengthy2 >= 64 && lengthy2 < 65) {
                feet1adjust = 2.7;
                feet2adjust = 4.7;
                picketadjust = -19.8;
                botadjust = -4.9;
                topadjust = -3.7;
                cornerposy = -26.5;
                facialadjust1x = -26.3;
                facialadjust2x = -19.0;
                floorpos = -3.9;
                firstadjust = 0.2975;
                completeadjustx = 1.57;
                completeadjusty = -0.16;
                measureadjust = 1.165;
              }
              if (lengthy2 >= 65 && lengthy2 < 66) {
                feet1adjust = 2.6;
                feet2adjust = 4.6;
                picketadjust = -19.5;
                botadjust = -4.8;
                topadjust = -3.6;
                cornerposy = -25.8;
                facialadjust1x = -25.7;
                facialadjust2x = -18.5;
                floorpos = -3.8;
                firstadjust = 0.3015;
                completeadjustx = 1.6;
                completeadjusty = -0.16;
                measureadjust = 1.185;
              }
              if (lengthy2 >= 66 && lengthy2 < 67) {
                feet1adjust = 2.6;
                feet2adjust = 4.6;
                picketadjust = -19.2;
                botadjust = -4.7;
                topadjust = -3.5;
                cornerposy = -25.2;
                facialadjust1x = -25.2;
                facialadjust2x = -17.8;
                floorpos = -3.7;
                firstadjust = 0.2975;
                completeadjustx = 1.6;
                completeadjusty = -0.16;
                measureadjust = 1.185;
              }
              if (lengthy2 >= 67 && lengthy2 < 68) {
                feet1adjust = 2.4;
                feet2adjust = 4.3;
                picketadjust = -18.8;
                botadjust = -4.6;
                topadjust = -3.4;
                cornerposy = -24.5;
                facialadjust1x = -24.6;
                facialadjust2x = -17.6;
                floorpos = -3.6;
                firstadjust = 0.2975;
                completeadjustx = 1.61;
                completeadjusty = -0.16;
                measureadjust = 1.185;
              }
              if (lengthy2 >= 68 && lengthy2 < 69) {
                feet1adjust = 2.3;
                feet2adjust = 4.1;
                picketadjust = -18.7;
                botadjust = -4.6;
                topadjust = -3.2;
                cornerposy = -23.9;
                facialadjust1x = -24.0;
                facialadjust2x = -17;
                floorpos = -3.5;
                firstadjust = 0.2975;
                completeadjustx = 1.62;
                completeadjusty = -0.16;
                measureadjust = 1.199;
              }
              if (lengthy2 >= 69 && lengthy2 < 70) {
                feet1adjust = 2.2;
                feet2adjust = 4;
                picketadjust = -18.5;
                botadjust = -4.4;
                topadjust = -3.0;
                cornerposy = -23.3;
                facialadjust1x = -23.3;
                facialadjust2x = -16.9;
                floorpos = -3.4;
                firstadjust = 0.301;
                completeadjustx = 1.635;
                completeadjusty = -0.16;
                measureadjust = 1.195;
              }
              if (lengthy2 >= 70 && lengthy2 < 71) {
                feet1adjust = 2.1;
                feet2adjust = 3.85;
                picketadjust = -16.5;
                botadjust = -4.4;
                topadjust = -3.2;
                cornerposy = -22.8;
                facialadjust1x = -22.9;
                facialadjust2x = -16.5;
                floorpos = -3.3;
                firstadjust = 0.3;
                completeadjustx = 1.64;
                completeadjusty = -0.16;
                measureadjust = 1.195;
              }
              if (lengthy2 >= 71 && lengthy2 < 72) {
                feet1adjust = 2;
                feet2adjust = 3.7;
                picketadjust = -15.8;
                botadjust = -4.2;
                topadjust = -3.1;
                cornerposy = -22.1;
                facialadjust1x = -22.3;
                facialadjust2x = -16.1;
                floorpos = -3.2;
                firstadjust = 0.3;
                completeadjustx = 1.65;
                completeadjusty = -0.16;
                measureadjust = 1.19;
              }
              if (lengthy2 >= 72 && lengthy2 < 73) {
                feet1adjust = 1.9;
                feet2adjust = 3.55;
                picketadjust = -15.4;
                botadjust = -4.1;
                topadjust = -3.0;
                cornerposy = -21.5;
                facialadjust1x = -21.8;
                facialadjust2x = -15.6;
                floorpos = -3.1;
                firstadjust = 0.3;
                completeadjustx = 1.665;
                completeadjusty = -0.16;
                measureadjust = 1.21;
              }
              if (lengthy2 >= 73 && lengthy2 < 74) {
                feet1adjust = 1.8;
                feet2adjust = 3.45;
                picketadjust = -15.2;
                botadjust = -4.1;
                topadjust = -3.0;
                cornerposy = -20.9;
                facialadjust1x = -21.2;
                facialadjust2x = -15.1;
                floorpos = -3;
                firstadjust = 0.3;
                completeadjustx = 1.68;
                completeadjusty = -0.16;
                measureadjust = 1.25;
              }
              if (lengthy2 >= 74 && lengthy2 < 75) {
                feet1adjust = 1.7;
                feet2adjust = 3.45;
                picketadjust = -14.8;
                botadjust = -3.9;
                topadjust = -2.8;
                cornerposy = -20.2;
                facialadjust1x = -20.7;
                facialadjust2x = -14.7;
                floorpos = -2.8;
                firstadjust = 0.2975;
                completeadjustx = 1.69;
                completeadjusty = -0.16;
                measureadjust = 1.25;
              }
              if (lengthy2 >= 75 && lengthy2 < 76) {
                feet1adjust = 1.7;
                feet2adjust = 3.3;
                picketadjust = -14.6;
                botadjust = -3.7;
                topadjust = -2.8;
                cornerposy = -19.6;
                facialadjust1x = -20.1;
                facialadjust2x = -14.2;
                floorpos = -2.7;
                firstadjust = 0.2975;
                completeadjustx = 1.7;
                completeadjusty = -0.16;
                measureadjust = 1.255;
              }
              if (lengthy2 >= 76 && lengthy2 < 77) {
                feet1adjust = 1.7;
                feet2adjust = 3.15;
                picketadjust = -14.4;
                botadjust = -3.6;
                topadjust = -2.6;
                cornerposy = -19;
                facialadjust1x = -19.5;
                facialadjust2x = -13.8;
                floorpos = -2.6;
                firstadjust = 0.2975;
                completeadjustx = 1.705;
                completeadjusty = -0.16;
                measureadjust = 1.24;
              }
              if (lengthy2 >= 77 && lengthy2 < 78) {
                feet1adjust = 1.65;
                feet2adjust = 3.1;
                picketadjust = -14.8;
                botadjust = -3.5;
                topadjust = -2.4;
                cornerposy = -18.4;
                facialadjust1x = -19.1;
                facialadjust2x = -13.4;
                floorpos = -2.5;
                firstadjust = 0.2955;
                completeadjustx = 1.7;
                completeadjusty = -0.16;
                measureadjust = 1.22;
              }
              if (lengthy2 >= 78 && lengthy2 < 79) {
                feet1adjust = 1.6;
                feet2adjust = 3;
                picketadjust = -14.3;
                botadjust = -3.5;
                topadjust = -2.4;
                cornerposy = -17.8;
                facialadjust1x = -18.5;
                facialadjust2x = -13;
                floorpos = -2.3;
                firstadjust = 0.2935;
                completeadjustx = 1.705;
                completeadjusty = -0.16;
                measureadjust = 1.235;
              }
              if (lengthy2 >= 79 && lengthy2 < 80) {
                feet1adjust = 1.55;
                feet2adjust = 2.9;
                picketadjust = -14.1;
                botadjust = -3.5;
                topadjust = -2.4;
                cornerposy = -17.2;
                facialadjust1x = -17.9;
                facialadjust2x = -12.6;
                floorpos = -2.2;
                firstadjust = 0.2925;
                completeadjustx = 1.71;
                completeadjusty = -0.16;
                measureadjust = 1.235;
              }
              if (lengthy2 >= 80 && lengthy2 < 81) {
                feet1adjust = 1.4;
                feet2adjust = 2.8;
                picketadjust = -12.3;
                botadjust = -3.2;
                topadjust = -2.1;
                cornerposy = -16.6;
                facialadjust1x = -17.3;
                facialadjust2x = -12.1;
                floorpos = -2.1;
                firstadjust = 0.2915;
                completeadjustx = 1.725;
                completeadjusty = -0.16;
                measureadjust = 1.25;
              }
              if (lengthy2 >= 81 && lengthy2 < 82) {
                feet1adjust = 1.3;
                feet2adjust = 2.7;
                picketadjust = -11.9;
                botadjust = -3.1;
                topadjust = -2.0;
                cornerposy = -15.9;
                facialadjust1x = -16.4;
                facialadjust2x = -11.7;
                floorpos = -2;
                firstadjust = 0.2915;
                completeadjustx = 1.735;
                completeadjusty = -0.16;
                measureadjust = 1.25;
              }
              if (lengthy2 >= 82 && lengthy2 < 83) {
                feet1adjust = 1.2;
                feet2adjust = 2.55;
                picketadjust = -11.7;
                botadjust = -3.1;
                topadjust = -2.3;
                cornerposy = -15.4;
                facialadjust1x = -15.8;
                facialadjust2x = -11.2;
                floorpos = -1.9;
                firstadjust = 0.2915;
                completeadjustx = 1.745;
                completeadjusty = -0.16;
                measureadjust = 1.25;
              }
              if (lengthy2 >= 83 && lengthy2 < 84) {
                feet1adjust = 1.15;
                feet2adjust = 2.4;
                picketadjust = -11.5;
                botadjust = -3.1;
                topadjust = -2.3;
                cornerposy = -14.8;
                facialadjust1x = -15.2;
                facialadjust2x = -10.8;
                floorpos = -1.8;
                firstadjust = 0.2915;
                completeadjustx = 1.755;
                completeadjusty = -0.16;
                measureadjust = 1.25;
              }
              if (lengthy2 >= 84 && lengthy2 < 85) {
                feet1adjust = 1.1;
                feet2adjust = 2.3;
                picketadjust = -11.1;
                botadjust = -3;
                topadjust = -2;
                cornerposy = -14.5;
                facialadjust1x = -14.6;
                facialadjust2x = -10.45;
                floorpos = -1.7;
                firstadjust = 0.2895;
                completeadjustx = 1.76;
                completeadjusty = -0.16;
                measureadjust = 1.25;
              }
              if (lengthy2 >= 85 && lengthy2 < 86) {
                feet1adjust = 1.0;
                feet2adjust = 2.2;
                picketadjust = -10.8;
                botadjust = -2.9;
                topadjust = -1.9;
                cornerposy = -14;
                facialadjust1x = -14.1;
                facialadjust2x = -10.1;
                floorpos = -1.6;
                firstadjust = 0.2895;
                completeadjustx = 1.77;
                completeadjusty = -0.16;
                measureadjust = 1.25;
              }
              if (lengthy2 >= 86 && lengthy2 < 87) {
                feet1adjust = 0.95;
                feet2adjust = 2.1;
                picketadjust = -10.5;
                botadjust = -2.9;
                topadjust = -1.9;
                cornerposy = -13.4;
                facialadjust1x = -13.8;
                facialadjust2x = -9.6;
                floorpos = -1.3;
                firstadjust = 0.287;
                completeadjustx = 1.772;
                completeadjusty = -0.16;
                measureadjust = 1.25;
              }
              if (lengthy2 >= 87 && lengthy2 < 88) {
                feet1adjust = 0.95;
                feet2adjust = 2.0;
                picketadjust = -10.2;
                botadjust = -2.8;
                topadjust = -1.8;
                cornerposy = -12.8;
                facialadjust1x = -13.2;
                facialadjust2x = -9.2;
                floorpos = -1.2;
                firstadjust = 0.286;
                completeadjustx = 1.776;
                completeadjusty = -0.16;
                measureadjust = 1.24;
              }
              if (lengthy2 >= 88 && lengthy2 < 89) {
                feet1adjust = 0.85;
                feet2adjust = 1.9;
                picketadjust = -10;
                botadjust = -2.8;
                topadjust = -1.8;
                cornerposy = -12.3;
                facialadjust1x = -12.8;
                facialadjust2x = -8.9;
                floorpos = -1.1;
                firstadjust = 0.285;
                completeadjustx = 1.79;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 89 && lengthy2 < 90) {
                feet1adjust = 0.85;
                feet2adjust = 1.85;
                picketadjust = -9.8;
                botadjust = -2.8;
                topadjust = -1.8;
                cornerposy = -11.8;
                facialadjust1x = -12.1;
                facialadjust2x = -8.5;
                floorpos = -1;
                firstadjust = 0.283;
                completeadjustx = 1.795;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 90 && lengthy2 < 91) {
                feet1adjust = 0.75;
                feet2adjust = 1.7;
                picketadjust = -7.8;
                botadjust = -2.6;
                topadjust = -1.7;
                cornerposy = -11.2;
                facialadjust1x = -11.6;
                facialadjust2x = -8.1;
                floorpos = -0.85;
                firstadjust = 0.281;
                completeadjustx = 1.797;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 91 && lengthy2 < 92) {
                feet1adjust = 0.8;
                feet2adjust = 1.55;
                picketadjust = -7.6;
                botadjust = -2.6;
                topadjust = -1.6;
                cornerposy = -10.6;
                facialadjust1x = -11;
                facialadjust2x = -7.6;
                floorpos = -0.7;
                firstadjust = 0.279;
                completeadjustx = 1.8;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 92 && lengthy2 < 93) {
                feet1adjust = 0.8;
                feet2adjust = 1.45;
                picketadjust = -6.7;
                botadjust = -2.4;
                topadjust = -1.5;
                cornerposy = -10.1;
                facialadjust1x = -10.5;
                facialadjust2x = -7.2;
                floorpos = -0.6;
                firstadjust = 0.278;
                completeadjustx = 1.805;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 93 && lengthy2 < 94) {
                feet1adjust = 0.7;
                feet2adjust = 1.3;
                picketadjust = -6.5;
                botadjust = -2.3;
                topadjust = -1.3;
                cornerposy = -9.6;
                facialadjust1x = -10;
                facialadjust2x = -6.9;
                floorpos = -0.5;
                firstadjust = 0.277;
                completeadjustx = 1.81;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 94 && lengthy2 < 95) {
                feet1adjust = 0.6;
                feet2adjust = 1.2;
                picketadjust = -6.2;
                botadjust = -2.3;
                topadjust = -1.3;
                cornerposy = -9.1;
                facialadjust1x = -9.3;
                facialadjust2x = -6.5;
                floorpos = -0.5;
                firstadjust = 0.276;
                completeadjustx = 1.816;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 95 && lengthy2 < 96) {
                feet1adjust = 0.5;
                feet2adjust = 1.1;
                picketadjust = -5.9;
                botadjust = -2.2;
                topadjust = -1.2;
                cornerposy = -8.5;
                facialadjust1x = -8.7;
                facialadjust2x = -6.1;
                floorpos = -0.7;
                firstadjust = 0.283;
                completeadjustx = 1.833;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 96 && lengthy2 < 97) {
                feet1adjust = 0.5;
                feet2adjust = 1;
                picketadjust = -5.2;
                botadjust = -2.1;
                topadjust = -1.1;
                cornerposy = -7.9;
                facialadjust1x = -8.1;
                facialadjust2x = -5.8;
                floorpos = -0.7;
                firstadjust = 0.284;
                completeadjustx = 1.839;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 97 && lengthy2 < 98) {
                feet1adjust = 0.4;
                feet2adjust = 1.1;
                picketadjust = -5.1;
                botadjust = -2.1;
                topadjust = -1.1;
                cornerposy = -7.3;
                facialadjust1x = -7.6;
                facialadjust2x = -5.4;
                floorpos = -0.65;
                firstadjust = 0.283;
                completeadjustx = 1.842;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 98 && lengthy2 < 99) {
                feet1adjust = 0.35;
                feet2adjust = 1;
                picketadjust = -4.7;
                botadjust = -2.0;
                topadjust = -0.9;
                cornerposy = -6.5;
                facialadjust1x = -7.0;
                facialadjust2x = -5;
                floorpos = -0.65;
                firstadjust = 0.284;
                completeadjustx = 1.849;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 99 && lengthy2 < 100) {
                feet1adjust = 0.3;
                feet2adjust = 0.9;
                picketadjust = -4.4;
                botadjust = -2.0;
                topadjust = -0.9;
                cornerposy = -6;
                facialadjust1x = -6.5;
                facialadjust2x = -4.8;
                floorpos = 0.5;
                firstadjust = 0.266;
                completeadjustx = 1.853;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 100 && lengthy2 < 101) {
                feet1adjust = 0.2;
                feet2adjust = 0.8;
                picketadjust = -2.9;
                botadjust = -1.8;
                topadjust = -0.7;
                cornerposy = -5.5;
                facialadjust1x = -5.8;
                facialadjust2x = -4.4;
                floorpos = -0.5;
                firstadjust = 0.286;
                completeadjustx = 1.87;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 101 && lengthy2 < 102) {
                feet1adjust = 0.15;
                feet2adjust = 0.75;
                picketadjust = -2.7;
                botadjust = -1.8;
                topadjust = -0.7;
                cornerposy = -5;
                facialadjust1x = -5.1;
                facialadjust2x = -4;
                floorpos = -0.3;
                firstadjust = 0.284;
                completeadjustx = 1.875;
                completeadjusty = -0.16;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 102 && lengthy2 < 103) {
                feet1adjust = 0.1;
                feet2adjust = 0.7;
                picketadjust = -2.5;
                botadjust = -1.7;
                topadjust = -0.6;
                cornerposy = -4.5;
                facialadjust1x = -4.6;
                facialadjust2x = -3.5;
                floorpos = -0.2;
                firstadjust = 0.2835;
                completeadjustx = 1.885;
                completeadjusty = -0.16;
                measureadjust = 1.28;
              }
              if (lengthy2 >= 103 && lengthy2 < 104) {
                feet1adjust = 0.1;
                feet2adjust = 0.6;
                picketadjust = -2.2;
                botadjust = -1.7;
                topadjust = -0.6;
                cornerposy = -4;
                facialadjust1x = -4;
                facialadjust2x = -3;
                floorpos = -0.3;
                firstadjust = 0.283;
                completeadjustx = 1.88;
                completeadjusty = -0.17;
                measureadjust = 1.28;
              }
              if (lengthy2 >= 104 && lengthy2 < 105) {
                feet1adjust = 0.05;
                feet2adjust = 0.5;
                picketadjust = -1.9;
                botadjust = -1.5;
                topadjust = -0.35;
                cornerposy = -3.5;
                facialadjust1x = -3.4;
                facialadjust2x = -2.5;
                floorpos = -0.3;
                firstadjust = 0.285;
                completeadjustx = 1.89;
                completeadjusty = -0.17;
                measureadjust = 1.28;
              }
              if (lengthy2 >= 105 && lengthy2 < 106) {
                feet1adjust = 0;
                feet2adjust = 0.4;
                picketadjust = -1.6;
                botadjust = -1.4;
                topadjust = -0.3;
                cornerposy = -3;
                facialadjust1x = -2.8;
                facialadjust2x = -2.1;
                floorpos = -0.2;
                firstadjust = 0.284;
                completeadjustx = 1.895;
                completeadjusty = -0.17;
                measureadjust = 1.28;
              }
              if (lengthy2 >= 106 && lengthy2 < 107) {
                feet1adjust = -0.05;
                feet2adjust = 0.3;
                picketadjust = -1.3;
                botadjust = -1.35;
                topadjust = -0.25;
                cornerposy = -2.5;
                facialadjust1x = -2.1;
                facialadjust2x = -1.6;
                floorpos = -0.1;
                firstadjust = 0.282;
                completeadjustx = 1.9;
                completeadjusty = -0.17;
                measureadjust = 1.28;
              }
              if (lengthy2 >= 107 && lengthy2 < 108) {
                feet1adjust = -0.1;
                feet2adjust = 0.25;
                picketadjust = -1;
                botadjust = -1.3;
                topadjust = -0.2;
                cornerposy = -2;
                facialadjust1x = -1.5;
                facialadjust2x = -1.1;
                floorpos = 0;
                firstadjust = 0.2805;
                completeadjustx = 1.895;
                completeadjusty = -0.17;
                measureadjust = 1.28;
              }
              if (lengthy2 >= 108 && lengthy2 < 109) {
                feet1adjust = -0.15;
                feet2adjust = 0.2;
                picketadjust = -0.7;
                botadjust = -1.2;
                topadjust = -0.15;
                cornerposy = -1.5;
                facialadjust1x = -0.9;
                facialadjust2x = -0.8;
                floorpos = 0.1;
                firstadjust = 0.2795;
                completeadjustx = 1.9;
                completeadjusty = -0.17;
                measureadjust = 1.285;
              }
              if (lengthy2 >= 109 && lengthy2 < 110) {
                feet1adjust = -0.2;
                feet2adjust = 0.1;
                picketadjust = -0.3;
                botadjust = -1.2;
                topadjust = -0.15;
                cornerposy = -1;
                facialadjust1x = -0.3;
                facialadjust2x = -0.2;
                floorpos = 0.2;
                firstadjust = 0.279;
                completeadjustx = 1.91;
                completeadjusty = -0.17;
                measureadjust = 1.285;
              }
              if (lengthy2 >= 110 && lengthy2 < 111) {
                feet1adjust = -0.2;
                feet2adjust = 0;
                picketadjust = 0.8;
                botadjust = -1.0;
                topadjust = 0;
                cornerposy = -0.5;
                facialadjust1x = 0.3;
                facialadjust2x = -0;
                floorpos = 0.3;
                firstadjust = 0.2775;
                completeadjustx = 1.91;
                completeadjusty = -0.17;
                measureadjust = 1.275;
              }
              if (lengthy2 >= 111 && lengthy2 < 112) {
                feet1adjust = -0.25;
                feet2adjust = -0.1;
                picketadjust = 1.1;
                botadjust = -1.0;
                topadjust = 0.1;
                cornerposy = 0;
                facialadjust1x = 0.8;
                facialadjust2x = 0.4;
                floorpos = 0.4;
                firstadjust = 0.2775;
                completeadjustx = 1.915;
                completeadjusty = -0.17;
                measureadjust = 1.275;
              }
              if (lengthy2 >= 112 && lengthy2 < 113) {
                feet1adjust = -0.3;
                feet2adjust = -0.15;
                picketadjust = 1.4;
                botadjust = -0.7;
                topadjust = 0.2;
                cornerposy = 0.5;
                facialadjust1x = 1.3;
                facialadjust2x = 0.8;
                floorpos = 0.3;
                firstadjust = 0.2775;
                completeadjustx = 1.919;
                completeadjusty = -0.17;
                measureadjust = 1.275;
              }
              if (lengthy2 >= 113 && lengthy2 < 114) {
                feet1adjust = -0.4;
                feet2adjust = -0.2;
                picketadjust = 1.6;
                botadjust = -0.6;
                topadjust = 0.3;
                cornerposy = 1;
                facialadjust1x = 1.8;
                facialadjust2x = 1.2;
                floorpos = 0.4;
                firstadjust = 0.2775;
                completeadjustx = 1.927;
                completeadjusty = -0.17;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 114 && lengthy2 < 115) {
                feet1adjust = -0.5;
                feet2adjust = -0.25;
                picketadjust = 1.8;
                botadjust = -0.5;
                topadjust = 0.4;
                cornerposy = 1.5;
                facialadjust1x = 2.3;
                facialadjust2x = 1.6;
                floorpos = 0.5;
                firstadjust = 0.2775;
                completeadjustx = 1.939;
                completeadjusty = -0.17;
                measureadjust = 1.27;
              }
              if (lengthy2 >= 115 && lengthy2 < 116) {
                feet1adjust = -0.55;
                feet2adjust = -0.35;
                picketadjust = 2.3;
                botadjust = -0.4;
                topadjust = 0.5;
                cornerposy = 2;
                facialadjust1x = 2.9;
                facialadjust2x = 2;
                floorpos = 0.5;
                firstadjust = 0.279;
                completeadjustx = 1.949;
                completeadjusty = -0.17;
                measureadjust = 1.265;
              }
              if (lengthy2 >= 116 && lengthy2 < 117) {
                feet1adjust = -0.6;
                feet2adjust = -0.45;
                picketadjust = 2.8;
                botadjust = -0.3;
                topadjust = 0.6;
                cornerposy = 2.5;
                facialadjust1x = 3.3;
                facialadjust2x = 2.4;
                floorpos = 0.6;
                firstadjust = 0.2775;
                completeadjustx = 1.959;
                completeadjusty = -0.17;
                measureadjust = 1.265;
              }
              if (lengthy2 >= 117 && lengthy2 < 118) {
                feet1adjust = -0.7;
                feet2adjust = -0.55;
                picketadjust = 3;
                botadjust = -0.3;
                topadjust = 0.6;
                cornerposy = 3;
                facialadjust1x = 3.8;
                facialadjust2x = 2.8;
                floorpos = 0.7;
                firstadjust = 0.2775;
                completeadjustx = 1.966;
                completeadjusty = -0.17;
                measureadjust = 1.26;
              }
              if (lengthy2 >= 118 && lengthy2 < 119) {
                feet1adjust = -0.75;
                feet2adjust = -0.7;
                picketadjust = 3.3;
                botadjust = -0.1;
                topadjust = 0.7;
                cornerposy = 3.5;
                facialadjust1x = 4.3;
                facialadjust2x = 3.2;
                floorpos = 0.75;
                firstadjust = 0.2775;
                completeadjustx = 1.97;
                completeadjusty = -0.17;
                measureadjust = 1.26;
              }
              if (lengthy2 >= 119 && lengthy2 < 120) {
                feet1adjust = -0.8;
                feet2adjust = -0.8;
                picketadjust = 3.7;
                botadjust = 0;
                topadjust = 0.8;
                cornerposy = 4;
                facialadjust1x = 4.9;
                facialadjust2x = 3.6;
                floorpos = 0.8;
                firstadjust = 0.2775;
                completeadjustx = 1.93;
                completeadjusty = -0.17;
                measureadjust = 1.26;
              }
              if (lengthy2 >= 120) {
                feet1adjust = -0.9;
                feet2adjust = -0.9;
                picketadjust = 5;
                botadjust = 0.1;
                topadjust = 0.9;
                cornerposy = 4.5;
                facialadjust1x = 5.5;
                facialadjust2x = 4;
                floorpos = 0.8;
                firstadjust = 0.264;
                completeadjustx = 1.89;
                completeadjusty = -0.17;
                measureadjust = 1.26;
                topperadjust = 4.1;
              }
            }
            let alignadjust = -7.55;
            let alignadjustscale = -0.131;
            topperadjust = -25.9 + (3 / 7) * divy;
            let lengthytop = parseInt(props.len1) + 70;
            if (para.count == 'en-us' || para.count == 'es-us') {
              lengthytop = parseFloat(props.len1 / 25.4 + 70 / 25.4).toFixed(2);
            }

            let lastflooradjust = (parseInt(lengthy2) - 50) * 0.0087142 + 0.48;

            if (pointies.length <= 2 && topmount) {
              lastflooradjust = lastflooradjust + ((parseInt(lengthy2) - 50) * -0.000257142 + 0.083);
              floorpos = floorpos + ((parseInt(lengthy2) - 50) * -0.004285741 + 4.3);
            }
            if (topmount && props.form == 'i') {
              lastflooradjust = lastflooradjust - 0.08;
              floorpos = floorpos - 3.5;
            }
            if (topmount && props.form == 'i' && pointies.length > 2) {
              lastflooradjust = lastflooradjust - 0.07;
              floorpos = floorpos - 4;
            }
            return (
              <>
                <group
                  {...props}
                  dispose={null}
                  scale={[0.1, 0.1, 0.1]}
                  position={[1.72 + completeadjusty, 0, midpoint[1] + completeadjustx]}
                  rotation-y={angle}
                >
                  <group position={[3.19, 44.74, 8.66]}>
                    <group position={[0.89, 23.76, -35.14 - picketadjust]}>{picketadd(scaler, singlelength)}</group>
                    <group visible={straighthandlauf} position={[0.86, 74.24, 8.64]}>
                      <mesh
                        geometry={nodes.Easy_Alu_Handrail_MOD5950_normal.geometry}
                        position={[0, heightmove, topadjust]}
                        scale={[handscalex, 1, handscaley]}
                        material={materials['physi alu']}
                      />
                      <mesh
                        geometry={nodes.Easy_Alu_Handrail_MOD5950_normal_Corner_R.geometry}
                        visible={false}
                        position={[cornerposx, heightmove, cornerposy]}
                        material={materials['physi alu']}
                      />
                      <mesh
                        geometry={nodes.Easy_Alu_Handrail_MOD5950_normal_Corner_L.geometry}
                        visible={initialcorner}
                        position={[cornerposx, heightmove, cornerposy]}
                        material={materials['physi alu']}
                      />
                    </group>
                    <group visible={bevelhandlauf} position={[0.86, 74.24, 8.64]}>
                      <mesh
                        geometry={nodes.Easy_Alu_Handrail_bevel.geometry}
                        position={[0, heightmove, topadjust]}
                        scale={[handscalex, 1, handscaley]}
                        material={materials['physi alu']}
                        material-color={colorr}
                      />
                      <mesh
                        geometry={nodes.Easy_Alu_Handrail_bevel_Corner_L.geometry}
                        visible={initialcorner}
                        position={[cornerposx, heightmove, cornerposy]}
                        material={materials['physi alu']}
                      />
                      <mesh
                        geometry={nodes.Easy_Alu_Handrail_bevel_Corner_R.geometry}
                        visible={false}
                        position={[cornerposx, heightmove, cornerposy]}
                        material={materials['physi alu']}
                      />
                    </group>
                    <group visible={true} position={[0.86, 75.54, 8.68]} rotation={[0, 1.57, 0]}>
                      {klammerrender(1)}
                      <mesh
                        visible={false}
                        geometry={nodes.Handrail_Connector_normal_R.geometry}
                        material={materials['physi alu']}
                        position={[56.02 + topperadjust, 0 + heightmove, 0]}
                      />
                      <mesh
                        visible={false}
                        geometry={nodes.Handrail_Connector_bevel_R.geometry}
                        material={materials['physi alu']}
                        position={[56.02 + topperadjust, 0 + heightmove, 0]}
                      />
                      <mesh
                        visible={false}
                        geometry={nodes.Handrail_Connector_normal_L.geometry}
                        material={materials['physi alu']}
                        position={[-56.02, 0, 0]}
                      />
                      <mesh
                        visible={false}
                        geometry={nodes.Handrail_Connector_bevel_L.geometry}
                        material={materials['physi alu']}
                        position={[-56.02, 0, 0]}
                      />
                    </group>
                    <group visible={false} position={[0.61, 75.56, 8.63]}>
                      <mesh
                        geometry={nodes.Handrail_Corner_Connector_normal_R.geometry}
                        material={materials['physi alu']}
                        position={[0, 0, -60.49]}
                        rotation={[-Math.PI, Math.PI / 4, -Math.PI]}
                      />
                      <mesh
                        geometry={nodes.Handrail_Corner_Connector_bevel_R.geometry}
                        material={materials['physi alu']}
                        position={[0, 0, -60.49]}
                        rotation={[-Math.PI, Math.PI / 4, -Math.PI]}
                      />
                      <mesh
                        geometry={nodes.Handrail_Corner_Connector_normal_L.geometry}
                        material={materials['physi alu']}
                        position={[0, 0, 60.49]}
                        rotation={[0, Math.PI / 4, 0]}
                      />
                      <mesh
                        geometry={nodes.Handrail_Corner_Connector_bevel_L.geometry}
                        material={materials['physi alu']}
                        position={[0, 0, 60.49]}
                        rotation={[0, Math.PI / 4, 0]}
                      />
                    </group>
                    <group visible={topmount} position={[-4.68, -33.65, 6.16]} rotation={[0, 1.57, 0]}>
                      <mesh
                        geometry={nodes.Easy_Alu_Feet_Corner_L.geometry}
                        visible={initialcorner}
                        material={materials['physi alu']}
                        position={[-56.19 * scaler + feet1adjust, 1.64, 5.62]}
                      />
                      <mesh
                        geometry={nodes.Easy_Alu_Feet_Corner_R.geometry}
                        visible={false}
                        material={materials['physi alu']}
                        position={[51.15 * scaler + feet2adjust, 1.64, 5.62]}
                        rotation={[0, 0, -Math.PI]}
                      />
                      <mesh
                        geometry={nodes.Feet_L.geometry}
                        visible={generalcorner}
                        material={materials['physi alu']}
                        position={[-56.64 * scaler + feet1adjust, -0.03, 2.19]}
                      />
                      <mesh
                        geometry={nodes.Feet_R.geometry}
                        visible={true}
                        material={materials['physi alu']}
                        position={[56.64 * scaler + feet2adjust, 0.03, -2.19]}
                      />
                    </group>
                    <group position={[0.8, -43.86, -45.03]} visible={facial} rotation={[0, -1.57, 0]}>
                      <mesh
                        geometry={nodes.Feet_Fascia_L.geometry}
                        material={materials['physi alu']}
                        position={[107.41 + facialadjust1x, 11.86, -0.01]}
                        rotation={[0, 0, -Math.PI]}
                      />
                      <mesh
                        visible={facialplate1}
                        geometry={nodes.Feet_Adapter_Fascia_L.geometry}
                        material={materials['physi alu']}
                        position={[99.21 + facialadjust1x, 5.86, 2.63]}
                        rotation={[Math.PI, -1.57, 0]}
                      />
                      <mesh
                        geometry={nodes.Feet_Fascia_R.geometry}
                        material={materials['physi alu']}
                        position={[0.1 - facialadjust2x, -0.14, -0.08]}
                      />
                      <mesh
                        visible={false}
                        geometry={nodes.Feet_Adapter_Fascia_R.geometry}
                        material={materials['physi alu']}
                        position={[8.3 - facialadjust2x, 5.86, 2.63]}
                        rotation={[0, 1.57, 0]}
                      />
                    </group>
                    <mesh
                      geometry={nodes.Easy_Alu_frame_down.geometry}
                      material={materials['physi alu']}
                      scale={[1, 1 * scaler, 1]}
                      position={[0.75, -26.49, 9.11 + botadjust]}
                      rotation={[Math.PI / 2, 0, 0]}
                    />
                    <mesh
                      geometry={nodes.Easy_Alu_frame_R.geometry}
                      material={materials['physi alu']}
                      position={[0.77, 21.18 + heightmove / 2, -45.02 * scaler]}
                      scale={[1, heightscaler, 1]}
                    />
                    <mesh
                      geometry={nodes.Easy_Alu_frame_L.geometry}
                      material={materials['physi alu']}
                      position={[0.77, 21.18 + heightmove / 2, 62.39 * scaler]}
                      scale={[1, heightscaler, 1]}
                    />
                    <mesh
                      visible={false}
                      geometry={nodes.Glass.geometry}
                      material={materials['Glass Frosted']}
                      position={[0.65, 23.97, 8.66]}
                    />

                    {index < pointies.length - 2 ? (
                      <mesh
                        visible={topmount}
                        geometry={nodes.Floor_TOP.geometry}
                        material={materials['physi concrete']}
                        material-color={ugcol}
                        scale={[1, 1, floorscale + firstadjust + alignadjustscale]}
                        position={[-3.19 + alignadjust, -39.62, 8.66 + floorpos]}
                      />
                    ) : (
                      <mesh
                        visible={topmount}
                        geometry={nodes.Floor_TOP.geometry}
                        material={materials['physi concrete']}
                        material-color={ugcol}
                        scale={[1, 1, lastflooradjust]}
                        position={[-3.19 + alignadjust, -39.62, 8.66 + floorpos]}
                      />
                    )}

                    <mesh
                      visible={facial}
                      geometry={nodes.Floor_Fascia.geometry}
                      material={materials['physi concrete']}
                      scale={[1, 1, floorscale]}
                      position={[-17.84, -38.01, 8.66 + floorpos]}
                    />
                  </group>
                </group>

                {props.form == 'i' && (
                  <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                    <Line
                      points={[
                        [0.5 - 0.2, -4, pointies[pointies.length - 1][1] + measureadjust],
                        [
                          0.5 - 0.2,
                          -4,
                          pointies[0][1] +
                            measureadjust -
                            0.75 -
                            0.25 +
                            0.7 +
                            (0.25 - 0.003333 * Math.abs(50 - lengthy2)),
                        ],
                      ]}
                    />
                    <Line
                      points={[
                        [0.5 - 0.2, -4.5, pointies[pointies.length - 1][1] + measureadjust],
                        [0.5 - 0.2, -1.5, pointies[pointies.length - 1][1] + measureadjust],
                      ]}
                      dashed={false}
                    />

                    <Line
                      points={[
                        [
                          0.5 - 0.2,
                          -4.5,
                          pointies[0][1] +
                            measureadjust -
                            0.75 -
                            0.25 +
                            0.7 +
                            (0.25 - 0.003333 * Math.abs(50 - lengthy2)),
                        ],
                        [
                          0.5 - 0.2,
                          -1.5,
                          pointies[0][1] +
                            measureadjust -
                            0.75 -
                            0.25 +
                            0.7 +
                            (0.25 - 0.00333 * Math.abs(50 - lengthy2)),
                        ],
                      ]}
                      dashed={false}
                    />
                    <Text
                      color={'black'}
                      position={[0, -5 + textup, (pointies[0][1] + pointies[pointies.length - 1][1]) / 2]}
                      rotation-y={props.polarcoord}
                      scale={textscale}
                    >
                      A :{' '}
                      {para.count != ('en-us' || 'es-us')
                        ? props.len1 + ' mm'
                        : parseFloat(props.len1 / 25.4).toFixed(2) + ' "'}
                    </Text>
                    <Cone
                      position={[0.5 - 0.2, -4, pointies[pointies.length - 1][1] + measureadjust - 0.15]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-x={Math.PI / 2}
                    />
                    <Cone
                      position={[
                        0.5 - 0.2,
                        -4,
                        pointies[0][1] +
                          measureadjust -
                          0.75 -
                          0.25 +
                          0.15 +
                          0.75 +
                          (0.25 - 0.003333 * Math.abs(50 - lengthy2)),
                      ]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-x={-Math.PI / 2}
                    />
                  </group>
                )}
                {!props.wall1 && (
                  <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                    <Line
                      points={[
                        [1, 12.02 + heightset, pointies[pointies.length - 1][1] + measureadjust + 3],
                        [1, 1.03, pointies[pointies.length - 1][1] + measureadjust + 3],
                      ]}
                      dashed={false}
                    />
                    <Line
                      lineWidth={0.7}
                      points={[
                        [1, 12.02 + heightset, pointies[pointies.length - 1][1] + measureadjust + 0.8],
                        [1, 12.02 + heightset, pointies[pointies.length - 1][1] + measureadjust + 3.5],
                      ]}
                      dashed={false}
                    />
                    <Line
                      lineWidth={0.7}
                      points={[
                        [1, 1.03, pointies[pointies.length - 1][1] + measureadjust + 0.8 + facialmeasureadjust],
                        [1, 1.03, pointies[pointies.length - 1][1] + measureadjust + 3.5],
                      ]}
                      dashed={false}
                    />
                    <Text
                      color={'black'}
                      position={[1, 6, pointies[pointies.length - 1][1] + measureadjust + 6.2 + adjustheighttext]}
                      rotation-y={props.polarcoord}
                      scale={textscale}
                    >
                      {para.count != ('en-us' || 'es-us') ? props.hohe + ' mm' : muricaheight + ' "'}
                    </Text>
                    <Cone
                      position={[1, 1.2, pointies[pointies.length - 1][1] + measureadjust + 3]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-x={Math.PI}
                    />
                    <Cone
                      position={[1, 11.82 + heightset, pointies[pointies.length - 1][1] + measureadjust + 3]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-y={Math.PI / 2}
                    />
                  </group>
                )}

                {props.wall1 && (
                  <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                    <Line
                      points={[
                        [1 - 3, 12.02 + heightset, pointies[pointies.length - 1][1] + measureadjust],
                        [1 - 3, 1.03, pointies[pointies.length - 1][1] + measureadjust],
                      ]}
                      dashed={false}
                    />
                    <Line
                      lineWidth={0.7}
                      points={[
                        [1 - 1.2, 12.02 + heightset, pointies[pointies.length - 1][1] + measureadjust],
                        [1 - 3.5, 12.02 + heightset, pointies[pointies.length - 1][1] + measureadjust],
                      ]}
                      dashed={false}
                    />
                    <Line
                      lineWidth={0.7}
                      points={[
                        [1 - 1.2, 1.03, pointies[pointies.length - 1][1] + measureadjust],
                        [1 - 3.5, 1.03, pointies[pointies.length - 1][1] + measureadjust],
                      ]}
                      dashed={false}
                    />
                    <Text
                      color={'black'}
                      position={[1 - 6.2, 6, pointies[pointies.length - 1][1] + measureadjust + adjustheighttext]}
                      rotation-y={props.polarcoord}
                      scale={textscale}
                    >
                      {para.count != ('en-us' || 'es-us') ? props.hohe + ' mm' : muricaheight + ' "'}
                    </Text>
                    <Cone
                      position={[1 - 3, 1.2, pointies[pointies.length - 1][1] + measureadjust]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-x={Math.PI}
                    />
                    <Cone
                      position={[1 - 3, 11.82 + heightset, pointies[pointies.length - 1][1] + measureadjust]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-y={Math.PI / 2}
                    />
                  </group>
                )}

                {(props.form == 'u' || props.form == 'l') && facial && (
                  <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                    <Line
                      points={[
                        [0.5 - 0.2 + 0.72, -5, pointies[pointies.length - 1][1] + measureadjust - 0.1],
                        [0.5 - 0.2 + 0.72, -5, pointies[0][1] + measureadjust - 0.75 - 0.25 + 0.7],
                      ]}
                    />
                    <Line
                      points={[
                        [0.5 - 0.2 + 0.72, -0.5, pointies[pointies.length - 1][1] + measureadjust - 0.1],
                        [0.5 - 0.2 + 0.72, -5.5, pointies[pointies.length - 1][1] + measureadjust - 0.1],
                      ]}
                      dashed={false}
                    />
                    <Line
                      points={[
                        [0.5 - 0.2 + 0.72, -0.5, pointies[0][1] + measureadjust - 0.75 - 0.25 + 0.7],
                        [0.5 - 0.2 + 0.72, -5.5, pointies[0][1] + measureadjust - 0.75 - 0.25 + 0.7],
                      ]}
                      dashed={false}
                    />
                    <Text
                      color={'black'}
                      position={[0 + 1.03, -6 - textup - 1, (pointies[0][1] + pointies[pointies.length - 1][1]) / 2]}
                      rotation-y={props.polarcoord}
                      scale={textscale}
                    >
                      A :{' '}
                      {para.count != ('en-us' || 'es-us')
                        ? props.len1 + ' mm'
                        : parseFloat(props.len1 / 25.4).toFixed(2) + ' "'}
                    </Text>
                    <Cone
                      position={[0.5 - 0.2 + 0.72, -5, pointies[pointies.length - 1][1] + measureadjust - 0.15 - 0.125]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-x={Math.PI / 2}
                    />
                    <Cone
                      position={[0.5 - 0.2 + 0.72, -5, pointies[0][1] + measureadjust - 0.75 - 0.25 + 0.15 + 0.72]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-x={-Math.PI / 2}
                    />
                  </group>
                )}

                {(props.form == 'u' || props.form == 'l') && topmount && (
                  <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                    <Line
                      points={[
                        [0.5 - 0.2, -4, pointies[pointies.length - 1][1] + measureadjust],
                        [0.5 - 0.2, -4, pointies[0][1] + measureadjust - 0.75 - 0.25],
                      ]}
                    />
                    <Line
                      points={[
                        [0.5 - 0.2, -4.5, pointies[pointies.length - 1][1] + measureadjust],
                        [0.5 - 0.2, -1.5, pointies[pointies.length - 1][1] + measureadjust],
                      ]}
                      dashed={false}
                    />
                    <Line
                      points={[
                        [0.5 - 0.2, -4.5, pointies[0][1] + measureadjust - 0.75 - 0.25],
                        [0.5 - 0.2, -1.5, pointies[0][1] + measureadjust - 0.75 - 0.25],
                      ]}
                      dashed={false}
                    />
                    {topmount && (
                      <Text
                        color={'black'}
                        position={[0, -5 + textup, (pointies[0][1] + pointies[pointies.length - 1][1]) / 2]}
                        rotation-y={props.polarcoord}
                        scale={textscale}
                      >
                        A :{' '}
                        {para.count != ('en-us' || 'es-us')
                          ? props.len1 + ' mm'
                          : parseFloat(props.len1 / 25.4).toFixed(2) + ' "'}
                      </Text>
                    )}
                    {facial && (
                      <Text
                        color={'black'}
                        position={[0, -5 + textup, (pointies[0][1] + pointies[pointies.length - 1][1]) / 2]}
                        rotation-y={props.polarcoord}
                        scale={textscale}
                      >
                        {para.count == 'en-us' || para.count == 'es-us' ? lengthytop + ' "' : lengthytop + ' mm'}
                      </Text>
                    )}

                    <Cone
                      position={[0.5 - 0.2, -4, pointies[pointies.length - 1][1] + measureadjust - 0.15]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-x={Math.PI / 2}
                    />
                    <Cone
                      position={[0.5 - 0.2, -4, pointies[0][1] + measureadjust - 0.75 - 0.25 + 0.15]}
                      scale={[0.1, 0.4, 0.1]}
                      material-color={'black'}
                      rotation-x={-Math.PI / 2}
                    />
                  </group>
                )}

                {wallrender(measureadjust, 1)}
                {props.form == 'i' && wallrender(measureadjust, 4)}
              </>
            );
          }
        })}

        {(props.form == 'u' || props.form == 'l') &&
          pointies2.map((item, index) => {
            let angle = Math.PI / 2;
            if (index < pointies2.length - 1) {
              let currentCoord = item;
              let nextCoord = pointies2[index + 1];
              let scaler = singlelength2 / 11;
              let midpoint = [(currentCoord[0] + nextCoord[0]) / 2, (currentCoord[1] + nextCoord[1]) / 2];

              let lengthy2 = singlelength2 * 10;
              let handscalex = 1;
              let handscaley = scaler;
              let picketadjust = 0;
              let feet1adjust = 0;
              let feet2adjust = 0;
              let topadjust = 0;
              let botadjust = 0;
              let posiadjustmentx = 0;
              let cornerspecialadjust = -2.8;
              let corner1x = 0;
              let corner1y = 0;
              let corner2x = 0;
              let corner2y = 0;
              let facialadjust1x = 0;
              let facialadjust2x = 0;
              let floorscale = scaler;
              let floorpos = -5;
              let facialplate1 = false;
              let facialplate2 = false;
              let initialcornerr = true;
              let initialcornerl = true;
              let finalcornerr = false;
              let finalcornerl = false;
              let initialhandr = false;
              let initialhandl = false;
              let klammerrechts = 0;
              let klammerlinks = 0;
              let klammerrvis = false;
              let klammerlvis = false;
              let measureadjust = 0;
              let heightscaler = 1;
              let heightmove = 0;
              let klammerrvis2 = false;
              let klammerlvis2 = false;

              let topperadjust = 0;
              let divy = Math.abs(50 - lengthy2);

              if (props.hohe == 900) {
                heightscaler = 100 / 110;
                heightmove = -10;
              }
              if (props.hohe == 1000) {
                heightscaler = 105 / 110;
                heightmove = -5;
              }
              if (props.hohe == 1100) {
                heightscaler = 1;
                heightmove = 0;
              }

              if (index == 0) {
                initialcornerl = false;
                finalcornerl = true;
                initialhandr = true;
                klammerrvis = true;
                klammerrvis2 = true;
              }
              if (index == pointies2.length - 2) {
                initialcornerr = false;
                finalcornerr = true;
                initialhandl = true;
                klammerlvis2 = true;
                klammerlvis = true;
              }

              if (props.form != 'u') {
                initialhandl = false;
                klammerlvis = false;
                klammerlvis2 = false;
              }

              /*Continue here */
              if (index == 0) {
                facialplate1 = true;
              }

              if (index > 0 && index < pointies2.length - 2) {
                floorscale = floorscale + 0.37;
              }

              if (index == pointies2.length - 2) {
                facialplate2 = true;
              }
              if (index == pointies2.length - 2 && props.form == 'l' && topmount) {
                floorscale = floorscale + 0.37;
                finalcornerr = false;
                initialcornerr = true;
              }

              if (bevelhandlauf) {
                if (klammerlvis) {
                  klammerlvis = false;
                }
                if (klammerrvis) {
                  klammerrvis = false;
                }
              }
              if (straighthandlauf) {
                if (klammerlvis2) {
                  klammerlvis2 = false;
                }
                if (klammerrvis2) {
                  klammerrvis2 = false;
                }
              }

              let initializator = 1;
              if (initializator == 1) {
                if (lengthy2 >= 50 && lengthy2 < 51) {
                  feet1adjust = 3;
                  feet2adjust = 6.5;
                  picketadjust = -24.5;
                  botadjust = -5;
                  topadjust = -4.7;
                  posiadjustmentx = 0.5;
                  corner1y = 24.5;
                  corner2y = -34.3;
                  facialadjust1x = -34.1;
                  facialadjust2x = -24.6;
                  floorpos = -5;
                  cornerspecialadjust = -2.8;
                  klammerrechts = corner1y;
                  measureadjust = 1.85;
                  topperadjust = -35.3;
                }
                if (lengthy2 >= 51 && lengthy2 < 52) {
                  feet1adjust = 3;
                  feet2adjust = 6.4;
                  picketadjust = -24.3;
                  botadjust = -5;
                  topadjust = -4.7;
                  posiadjustmentx = 0.495;
                  corner1y = 24.2;
                  corner2y = -33.8;
                  facialadjust1x = -33.5;
                  facialadjust2x = -24.3;
                  floorpos = -5;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.85;
                }
                if (lengthy2 >= 52 && lengthy2 < 53) {
                  feet1adjust = 3;
                  feet2adjust = 6.35;
                  picketadjust = -24.1;
                  botadjust = -5;
                  topadjust = -4.7;
                  posiadjustmentx = 0.48;
                  corner1y = 23.7;
                  corner2y = -33.2;
                  facialadjust1x = -33;
                  facialadjust2x = -23.8;
                  floorpos = -4.75;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.85;
                }
                if (lengthy2 >= 53 && lengthy2 < 54) {
                  feet1adjust = 3.1;
                  feet2adjust = 6.2;
                  picketadjust = -24.1;
                  botadjust = -5;
                  topadjust = -4.5;
                  posiadjustmentx = 0.48;
                  corner1y = 23.2;
                  corner2y = -32.6;
                  facialadjust1x = -32.3;
                  facialadjust2x = -23.3;
                  floorpos = -4.7;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.85;
                }
                if (lengthy2 >= 54 && lengthy2 < 55) {
                  feet1adjust = 3.2;
                  feet2adjust = 6.1;
                  picketadjust = -23.8;
                  botadjust = -5;
                  topadjust = -4.4;
                  posiadjustmentx = 0.48;
                  corner1y = 22.7;
                  corner2y = -32;
                  facialadjust1x = -31.5;
                  facialadjust2x = -23;
                  floorpos = -4.65;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.85;
                }
                if (lengthy2 >= 55 && lengthy2 < 56) {
                  feet1adjust = 3.2;
                  feet2adjust = 6;
                  picketadjust = -23.2;
                  botadjust = -5;
                  topadjust = -4.4;
                  posiadjustmentx = 0.48;
                  corner1y = 22.1;
                  corner2y = -31.5;
                  facialadjust1x = -31;
                  facialadjust2x = -22.6;
                  floorpos = -4.6;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.85;
                }
                if (lengthy2 >= 56 && lengthy2 < 57) {
                  feet1adjust = 3.25;
                  feet2adjust = 5.8;
                  picketadjust = -23;
                  botadjust = -5;
                  topadjust = -4.3;
                  posiadjustmentx = 0.48;
                  corner1y = 21.6;
                  corner2y = -30.9;
                  facialadjust1x = -30.6;
                  facialadjust2x = -22;
                  floorpos = -4.5;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.85;
                }
                if (lengthy2 >= 57 && lengthy2 < 58) {
                  feet1adjust = 3.3;
                  feet2adjust = 5.7;
                  picketadjust = -22.9;
                  botadjust = -5.1;
                  topadjust = -4.2;
                  posiadjustmentx = 0.48;
                  corner1y = 21;
                  corner2y = -30.4;
                  facialadjust1x = -30.1;
                  facialadjust2x = -21.6;
                  floorpos = -4.5;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 58 && lengthy2 < 59) {
                  feet1adjust = 3.35;
                  feet2adjust = 5.5;
                  picketadjust = -22.1;
                  botadjust = -5.1;
                  topadjust = -4.1;
                  posiadjustmentx = 0.48;
                  corner1y = 20.8;
                  corner2y = -29.8;
                  facialadjust1x = -29.6;
                  facialadjust2x = -21.2;
                  floorpos = -4.45;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.9;
                }
                if (lengthy2 >= 59 && lengthy2 < 60) {
                  feet1adjust = 3.2;
                  feet2adjust = 5.4;
                  picketadjust = -21.8;
                  botadjust = -5.1;
                  topadjust = -4;
                  posiadjustmentx = 0.45;
                  corner1y = 20.5;
                  corner2y = -29.1;
                  facialadjust1x = -29;
                  facialadjust2x = -20.9;
                  floorpos = -4.4;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 60 && lengthy2 < 61) {
                  feet1adjust = 3.1;
                  feet2adjust = 5.2;
                  picketadjust = -20.5;
                  botadjust = -5.1;
                  topadjust = -4;
                  posiadjustmentx = 0.445;
                  corner1y = 19.9;
                  corner2y = -28.6;
                  facialadjust1x = -28.5;
                  facialadjust2x = -20.3;
                  floorpos = -4.35;
                  cornerspecialadjust = -2.8;
                  measureadjust = 1.89;
                }
                if (lengthy2 >= 61 && lengthy2 < 62) {
                  feet1adjust = 3.0;
                  feet2adjust = 5.1;
                  picketadjust = -20.3;
                  botadjust = -5;
                  topadjust = -3.95;
                  posiadjustmentx = 0.43;
                  corner1y = 19.5;
                  corner2y = -28.1;
                  facialadjust1x = -28;
                  facialadjust2x = -20.1;
                  floorpos = -4.2;
                  cornerspecialadjust = -2.5;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 62 && lengthy2 < 63) {
                  feet1adjust = 2.9;
                  feet2adjust = 5;
                  picketadjust = -20.1;
                  botadjust = -5;
                  topadjust = -3.9;
                  posiadjustmentx = 0.42;
                  corner1y = 19.1;
                  corner2y = -27.6;
                  facialadjust1x = -27.5;
                  facialadjust2x = -19.7;
                  floorpos = -4.1;
                  cornerspecialadjust = -2.4;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 63 && lengthy2 < 64) {
                  feet1adjust = 2.8;
                  feet2adjust = 4.9;
                  picketadjust = -19.9;
                  botadjust = -5;
                  topadjust = -3.8;
                  posiadjustmentx = 0.41;
                  corner1y = 18.8;
                  corner2y = -27.1;
                  facialadjust1x = -26.8;
                  facialadjust2x = -19.4;
                  floorpos = -4.0;
                  cornerspecialadjust = -2.3;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 64 && lengthy2 < 65) {
                  feet1adjust = 2.7;
                  feet2adjust = 4.7;
                  picketadjust = -19.8;
                  botadjust = -4.9;
                  topadjust = -3.7;
                  posiadjustmentx = 0.4;
                  corner1y = 18.4;
                  corner2y = -26.4;
                  facialadjust1x = -26.3;
                  facialadjust2x = -19.0;
                  floorpos = -3.9;
                  cornerspecialadjust = -2.1;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 65 && lengthy2 < 66) {
                  feet1adjust = 2.6;
                  feet2adjust = 4.6;
                  picketadjust = -19.5;
                  botadjust = -4.8;
                  topadjust = -3.6;
                  posiadjustmentx = 0.39;
                  corner1y = 18;
                  corner2y = -25.75;
                  facialadjust1x = -25.7;
                  facialadjust2x = -18.5;
                  floorpos = -3.8;
                  cornerspecialadjust = -2;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 66 && lengthy2 < 67) {
                  feet1adjust = 2.6;
                  feet2adjust = 4.6;
                  picketadjust = -19.2;
                  botadjust = -4.7;
                  topadjust = -3.5;
                  posiadjustmentx = 0.39;
                  corner1y = 17.6;
                  corner2y = -25.2;
                  facialadjust1x = -25.2;
                  facialadjust2x = -17.8;
                  floorpos = -3.7;
                  cornerspecialadjust = -2;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 67 && lengthy2 < 68) {
                  feet1adjust = 2.4;
                  feet2adjust = 4.3;
                  picketadjust = -18.8;
                  botadjust = -4.6;
                  topadjust = -3.4;
                  posiadjustmentx = 0.38;
                  corner1y = 17.1;
                  corner2y = -24.7;
                  facialadjust1x = -24.6;
                  facialadjust2x = -17.6;
                  floorpos = -3.6;
                  cornerspecialadjust = -2;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 68 && lengthy2 < 69) {
                  feet1adjust = 2.3;
                  feet2adjust = 4.1;
                  picketadjust = -18.7;
                  botadjust = -4.6;
                  topadjust = -3.2;
                  posiadjustmentx = 0.36;
                  corner1y = 16.8;
                  corner2y = -24;
                  facialadjust1x = -24.0;
                  facialadjust2x = -17;
                  floorpos = -3.5;
                  cornerspecialadjust = -2;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 69 && lengthy2 < 70) {
                  feet1adjust = 2.2;
                  feet2adjust = 4;
                  picketadjust = -18.5;
                  botadjust = -4.4;
                  topadjust = -3.0;
                  posiadjustmentx = 0.35;
                  corner1y = 16.5;
                  corner2y = -23.4;
                  facialadjust1x = -23.3;
                  facialadjust2x = -16.9;
                  floorpos = -3.4;
                  cornerspecialadjust = -2;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 70 && lengthy2 < 71) {
                  feet1adjust = 2.1;
                  feet2adjust = 3.85;
                  picketadjust = -16.5;
                  botadjust = -4.4;
                  topadjust = -3.2;
                  posiadjustmentx = 0.34;
                  corner1y = 16.2;
                  corner2y = -22.6;
                  facialadjust1x = -22.9;
                  facialadjust2x = -16.5;
                  floorpos = -3.3;
                  cornerspecialadjust = -2;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 71 && lengthy2 < 72) {
                  feet1adjust = 2;
                  feet2adjust = 3.7;
                  picketadjust = -15.8;
                  botadjust = -4.2;
                  topadjust = -3.1;
                  posiadjustmentx = 0.35;
                  corner1y = 15.9;
                  corner2y = -22.1;
                  facialadjust1x = -22.3;
                  facialadjust2x = -16.1;
                  floorpos = -3.2;
                  cornerspecialadjust = -1.8;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 72 && lengthy2 < 73) {
                  feet1adjust = 1.9;
                  feet2adjust = 3.55;
                  picketadjust = -15.4;
                  botadjust = -4.1;
                  topadjust = -3.0;
                  posiadjustmentx = 0.34;
                  corner1y = 15.5;
                  corner2y = -21.6;
                  facialadjust1x = -21.8;
                  facialadjust2x = -15.6;
                  floorpos = -3.1;
                  cornerspecialadjust = -1.6;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 73 && lengthy2 < 74) {
                  feet1adjust = 1.8;
                  feet2adjust = 3.45;
                  picketadjust = -15.2;
                  botadjust = -4.1;
                  topadjust = -3.0;
                  posiadjustmentx = 0.33;
                  corner1y = 15;
                  corner2y = -21;
                  facialadjust1x = -21.2;
                  facialadjust2x = -15.1;
                  floorpos = -3;
                  cornerspecialadjust = -1.5;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 74 && lengthy2 < 75) {
                  feet1adjust = 1.7;
                  feet2adjust = 3.45;
                  picketadjust = -14.8;
                  botadjust = -3.9;
                  topadjust = -2.8;
                  posiadjustmentx = 0.32;
                  corner1y = 14.6;
                  corner2y = -20.5;
                  facialadjust1x = -20.7;
                  facialadjust2x = -14.7;
                  floorpos = -2.8;
                  cornerspecialadjust = -1.4;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 75 && lengthy2 < 76) {
                  feet1adjust = 1.7;
                  feet2adjust = 3.3;
                  picketadjust = -14.6;
                  botadjust = -3.7;
                  topadjust = -2.8;
                  posiadjustmentx = 0.32;
                  corner1y = 14.2;
                  corner2y = -19.9;
                  facialadjust1x = -20.1;
                  facialadjust2x = -14.2;
                  floorpos = -2.7;
                  cornerspecialadjust = -1.4;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 76 && lengthy2 < 77) {
                  feet1adjust = 1.7;
                  feet2adjust = 3.15;
                  picketadjust = -14.4;
                  botadjust = -3.6;
                  topadjust = -2.6;
                  posiadjustmentx = 0.31;
                  corner1y = 13.9;
                  corner2y = -19.3;
                  facialadjust1x = -19.5;
                  facialadjust2x = -13.8;
                  floorpos = -2.6;
                  cornerspecialadjust = -1.4;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 77 && lengthy2 < 78) {
                  feet1adjust = 1.65;
                  feet2adjust = 3.1;
                  picketadjust = -14.8;
                  botadjust = -3.5;
                  topadjust = -2.4;
                  posiadjustmentx = 0.31;
                  corner1y = 13.6;
                  corner2y = -18.7;
                  facialadjust1x = -19.1;
                  facialadjust2x = -13.4;
                  floorpos = -2.5;
                  cornerspecialadjust = -1.3;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 78 && lengthy2 < 79) {
                  feet1adjust = 1.6;
                  feet2adjust = 3;
                  picketadjust = -14.3;
                  botadjust = -3.5;
                  topadjust = -2.4;
                  posiadjustmentx = 0.3;
                  corner1y = 13.2;
                  corner2y = -18.2;
                  facialadjust1x = -18.5;
                  facialadjust2x = -13;
                  floorpos = -2.3;
                  cornerspecialadjust = -1.2;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 79 && lengthy2 < 80) {
                  feet1adjust = 1.55;
                  feet2adjust = 2.9;
                  picketadjust = -14.1;
                  botadjust = -3.5;
                  topadjust = -2.4;
                  posiadjustmentx = 0.29;
                  corner1y = 12.8;
                  corner2y = -17.7;
                  facialadjust1x = -17.9;
                  facialadjust2x = -12.6;
                  floorpos = -2.2;
                  cornerspecialadjust = -1.1;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 80 && lengthy2 < 81) {
                  feet1adjust = 1.4;
                  feet2adjust = 2.7;
                  picketadjust = -12.3;
                  botadjust = -3.2;
                  topadjust = -2.1;
                  posiadjustmentx = 0.26;
                  corner1y = 12.4;
                  corner2y = -17.1;
                  facialadjust1x = -17.3;
                  facialadjust2x = -12.1;
                  floorpos = -2.1;
                  cornerspecialadjust = -1;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 81 && lengthy2 < 82) {
                  feet1adjust = 1.3;
                  feet2adjust = 2.7;
                  picketadjust = -11.9;
                  botadjust = -3.1;
                  topadjust = -2.0;
                  posiadjustmentx = 0.25;
                  corner1y = 12;
                  corner2y = -16.6;
                  facialadjust1x = -16.4;
                  facialadjust2x = -11.7;
                  floorpos = -2;
                  cornerspecialadjust = -0.9;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 82 && lengthy2 < 83) {
                  feet1adjust = 1.2;
                  feet2adjust = 2.55;
                  picketadjust = -11.7;
                  botadjust = -3.1;
                  topadjust = -2.3;
                  posiadjustmentx = 0.25;
                  corner1y = 11.7;
                  corner2y = -16.1;
                  facialadjust1x = -15.8;
                  facialadjust2x = -11.2;
                  floorpos = -1.9;
                  cornerspecialadjust = -0.85;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 83 && lengthy2 < 84) {
                  feet1adjust = 1.15;
                  feet2adjust = 2.4;
                  picketadjust = -11.5;
                  botadjust = -3.1;
                  topadjust = -2.3;
                  posiadjustmentx = 0.25;
                  corner1y = 11.2;
                  corner2y = -15.4;
                  facialadjust1x = -15.2;
                  facialadjust2x = -10.8;
                  floorpos = -1.8;
                  cornerspecialadjust = -0.8;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 84 && lengthy2 < 85) {
                  feet1adjust = 1.1;
                  feet2adjust = 2.3;
                  picketadjust = -11.1;
                  botadjust = -3;
                  topadjust = -2;
                  posiadjustmentx = 0.25;
                  corner1y = 10.8;
                  corner2y = -14.7;
                  facialadjust1x = -14.6;
                  facialadjust2x = -10.45;
                  floorpos = -1.7;
                  cornerspecialadjust = -0.9;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 85 && lengthy2 < 86) {
                  feet1adjust = 1.0;
                  feet2adjust = 2.2;
                  picketadjust = -10.8;
                  botadjust = -2.9;
                  topadjust = -1.9;
                  posiadjustmentx = 0.18;
                  corner1y = 10.4;
                  corner2y = -14;
                  facialadjust1x = -14.1;
                  facialadjust2x = -10.1;
                  floorpos = -1.6;
                  cornerspecialadjust = -0.8;
                  measureadjust = 1.87;
                }
                if (lengthy2 >= 86 && lengthy2 < 87) {
                  feet1adjust = 0.95;
                  feet2adjust = 2.1;
                  picketadjust = -10.5;
                  botadjust = -2.9;
                  topadjust = -1.9;
                  posiadjustmentx = 0.17;
                  corner1y = 10;
                  corner2y = -13.2;
                  facialadjust1x = -13.8;
                  facialadjust2x = -9.6;
                  floorpos = -1.3;
                  cornerspecialadjust = -0.7;
                  measureadjust = 1.87;
                }
                if (lengthy2 >= 87 && lengthy2 < 88) {
                  feet1adjust = 0.95;
                  feet2adjust = 2.0;
                  picketadjust = -10.2;
                  botadjust = -2.8;
                  topadjust = -1.8;
                  posiadjustmentx = 0.19;
                  corner1y = 9.6;
                  corner2y = -12.7;
                  facialadjust1x = -13.2;
                  facialadjust2x = -9.2;
                  floorpos = -1.2;
                  cornerspecialadjust = -0.6;
                  measureadjust = 1.87;
                }
                if (lengthy2 >= 88 && lengthy2 < 89) {
                  feet1adjust = 0.85;
                  feet2adjust = 1.9;
                  picketadjust = -10;
                  botadjust = -2.8;
                  topadjust = -1.8;
                  posiadjustmentx = 0.21;
                  corner1y = 9.2;
                  corner2y = -12.4;
                  facialadjust1x = -12.8;
                  facialadjust2x = -8.9;
                  floorpos = -1.1;
                  cornerspecialadjust = -0.2;
                  measureadjust = 1.87;
                }
                if (lengthy2 >= 89 && lengthy2 < 90) {
                  feet1adjust = 0.85;
                  feet2adjust = 1.85;
                  picketadjust = -9.8;
                  botadjust = -2.8;
                  topadjust = -1.8;
                  posiadjustmentx = 0.2;
                  corner1y = 8.8;
                  corner2y = -11.9;
                  facialadjust1x = -12.1;
                  facialadjust2x = -8.5;
                  floorpos = -1;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.2;
                  measureadjust = 1.87;
                }
                if (lengthy2 >= 90 && lengthy2 < 91) {
                  feet1adjust = 0.75;
                  feet2adjust = 1.7;
                  picketadjust = -7.8;
                  botadjust = -2.6;
                  topadjust = -1.7;
                  posiadjustmentx = 0.19;
                  corner1y = 8.4;
                  corner2y = -11.4;
                  facialadjust1x = -11.6;
                  facialadjust2x = -8.1;
                  floorpos = -0.85;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.3;
                  measureadjust = 1.86;
                }
                if (lengthy2 >= 91 && lengthy2 < 92) {
                  feet1adjust = 0.8;
                  feet2adjust = 1.55;
                  picketadjust = -7.6;
                  botadjust = -2.6;
                  topadjust = -1.6;
                  posiadjustmentx = 0.18;
                  corner1y = 8;
                  corner2y = -10.9;
                  facialadjust1x = -11;
                  facialadjust2x = -7.6;
                  floorpos = -0.7;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.2;
                  measureadjust = 1.86;
                }
                if (lengthy2 >= 92 && lengthy2 < 93) {
                  feet1adjust = 0.8;
                  feet2adjust = 1.45;
                  picketadjust = -6.7;
                  botadjust = -2.4;
                  topadjust = -1.5;
                  posiadjustmentx = 0.18;
                  corner1y = 7.7;
                  corner2y = -10.4;
                  facialadjust1x = -10.5;
                  facialadjust2x = -7.2;
                  floorpos = -0.6;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.2;
                  measureadjust = 1.88;
                }
                if (lengthy2 >= 93 && lengthy2 < 94) {
                  feet1adjust = 0.7;
                  feet2adjust = 1.3;
                  picketadjust = -6.5;
                  botadjust = -2.3;
                  topadjust = -1.3;
                  posiadjustmentx = 0.18;
                  corner1y = 7.3;
                  corner2y = -9.9;
                  facialadjust1x = -10;
                  facialadjust2x = -6.9;
                  floorpos = -0.5;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.2;
                  measureadjust = 1.92;
                }
                if (lengthy2 >= 94 && lengthy2 < 95) {
                  feet1adjust = 0.6;
                  feet2adjust = 1.2;
                  picketadjust = -6.2;
                  botadjust = -2.3;
                  topadjust = -1.3;
                  posiadjustmentx = 0.18;
                  corner1y = 6.8;
                  corner2y = -9.4;
                  facialadjust1x = -9.3;
                  facialadjust2x = -6.5;
                  floorpos = -0.5;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.92;
                }
                if (lengthy2 >= 95 && lengthy2 < 96) {
                  feet1adjust = 0.5;
                  feet2adjust = 1.1;
                  picketadjust = -5.9;
                  botadjust = -2.2;
                  topadjust = -1.2;
                  posiadjustmentx = 0.18;
                  corner1y = 6.2;
                  corner2y = -8.9;
                  facialadjust1x = -8.7;
                  facialadjust2x = -6.1;
                  floorpos = -0.7;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = 0;
                  measureadjust = 1.92;
                }
                if (lengthy2 >= 96 && lengthy2 < 97) {
                  feet1adjust = 0.5;
                  feet2adjust = 1;
                  picketadjust = -5.2;
                  botadjust = -2.1;
                  topadjust = -1.1;
                  posiadjustmentx = 0.18;
                  corner1y = 5.6;
                  corner2y = -8.3;
                  facialadjust1x = -8.1;
                  facialadjust2x = -5.8;
                  floorpos = -0.7;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = 0.1;
                  measureadjust = 1.93;
                }
                if (lengthy2 >= 97 && lengthy2 < 98) {
                  feet1adjust = 0.4;
                  feet2adjust = 1.1;
                  picketadjust = -5.1;
                  botadjust = -2.1;
                  topadjust = -1.1;
                  posiadjustmentx = 0.18;
                  corner1y = 5.0;
                  corner2y = -7.9;
                  facialadjust1x = -7.6;
                  facialadjust2x = -5.4;
                  floorpos = -0.65;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = 0.15;
                  measureadjust = 1.93;
                }
                if (lengthy2 >= 98 && lengthy2 < 99) {
                  feet1adjust = 0.35;
                  feet2adjust = 1;
                  picketadjust = -4.7;
                  botadjust = -2.0;
                  topadjust = -0.9;
                  posiadjustmentx = 0.18;
                  corner1y = 4.4;
                  corner2y = -7.4;
                  facialadjust1x = -7.0;
                  facialadjust2x = -5;
                  floorpos = -0.65;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = 0;
                  measureadjust = 1.94;
                }
                if (lengthy2 >= 99 && lengthy2 < 100) {
                  feet1adjust = 0.3;
                  feet2adjust = 0.9;
                  picketadjust = -4.4;
                  botadjust = -2.0;
                  topadjust = -0.9;
                  posiadjustmentx = 0.18;
                  corner1y = 3.6;
                  corner2y = -6.9;
                  facialadjust1x = -6.5;
                  facialadjust2x = -4.8;
                  floorpos = 0.5;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.95;
                }
                if (lengthy2 >= 100 && lengthy2 < 101) {
                  feet1adjust = 0.2;
                  feet2adjust = 0.8;
                  picketadjust = -2.9;
                  botadjust = -1.8;
                  topadjust = -0.7;
                  posiadjustmentx = 0.1;
                  corner1y = 3.6;
                  corner2y = -5.4;
                  facialadjust1x = -5.8;
                  facialadjust2x = -4.4;
                  floorpos = -0.5;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.91;
                }
                if (lengthy2 >= 101 && lengthy2 < 102) {
                  feet1adjust = 0.15;
                  feet2adjust = 0.75;
                  picketadjust = -2.7;
                  botadjust = -1.8;
                  topadjust = -0.7;
                  posiadjustmentx = 0.1;
                  corner1y = 3.2;
                  corner2y = -4.9;
                  facialadjust1x = -5.1;
                  facialadjust2x = -4;
                  floorpos = -0.3;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.91;
                }
                if (lengthy2 >= 102 && lengthy2 < 103) {
                  feet1adjust = 0.1;
                  feet2adjust = 0.7;
                  picketadjust = -2.5;
                  botadjust = -1.7;
                  topadjust = -0.6;
                  posiadjustmentx = 0.09;
                  corner1y = 3;
                  corner2y = -4.3;
                  facialadjust1x = -4.6;
                  facialadjust2x = -3.5;
                  floorpos = -0.2;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.92;
                }
                if (lengthy2 >= 103 && lengthy2 < 104) {
                  feet1adjust = 0.1;
                  feet2adjust = 0.6;
                  picketadjust = -2.2;
                  botadjust = -1.7;
                  topadjust = -0.6;
                  posiadjustmentx = 0.09;
                  corner1y = 2.6;
                  corner2y = -3.85;
                  facialadjust1x = -4;
                  facialadjust2x = -3;
                  floorpos = -0.3;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.9;
                }
                if (lengthy2 >= 104 && lengthy2 < 105) {
                  feet1adjust = 0.05;
                  feet2adjust = 0.5;
                  picketadjust = -1.9;
                  botadjust = -1.5;
                  topadjust = -0.35;
                  posiadjustmentx = 0.08;
                  corner1y = 2.2;
                  corner2y = -3.2;
                  facialadjust1x = -3.4;
                  facialadjust2x = -2.5;
                  floorpos = -0.3;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.91;
                }
                if (lengthy2 >= 105 && lengthy2 < 106) {
                  feet1adjust = 0;
                  feet2adjust = 0.4;
                  picketadjust = -1.6;
                  botadjust = -1.4;
                  topadjust = -0.3;
                  posiadjustmentx = 0.08;
                  corner1y = 1.9;
                  corner2y = -2.7;
                  facialadjust1x = -2.8;
                  facialadjust2x = -2.1;
                  floorpos = -0.2;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.91;
                }
                if (lengthy2 >= 106 && lengthy2 < 107) {
                  feet1adjust = -0.05;
                  feet2adjust = 0.3;
                  picketadjust = -1.3;
                  botadjust = -1.35;
                  topadjust = -0.25;
                  posiadjustmentx = 0.08;
                  corner1y = 1.6;
                  corner2y = -2;
                  facialadjust1x = -2.1;
                  facialadjust2x = -1.6;
                  floorpos = -0.1;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.94;
                }
                if (lengthy2 >= 107 && lengthy2 < 108) {
                  feet1adjust = -0.1;
                  feet2adjust = 0.25;
                  picketadjust = -1;
                  botadjust = -1.3;
                  topadjust = -0.2;
                  posiadjustmentx = 0.08;
                  corner1y = 0.7;
                  corner2y = -1.5;
                  facialadjust1x = -1.5;
                  facialadjust2x = -1.1;
                  floorpos = 0;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.94;
                }
                if (lengthy2 >= 108 && lengthy2 < 109) {
                  feet1adjust = -0.15;
                  feet2adjust = 0.2;
                  picketadjust = -0.7;
                  botadjust = -1.2;
                  topadjust = -0.15;
                  posiadjustmentx = 0.08;
                  corner1y = 0.1;
                  corner2y = -1;
                  facialadjust1x = -0.9;
                  facialadjust2x = -0.8;
                  floorpos = 0.1;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.94;
                }
                if (lengthy2 >= 109 && lengthy2 < 110) {
                  feet1adjust = -0.2;
                  feet2adjust = 0.1;
                  picketadjust = -0.3;
                  botadjust = -1.2;
                  topadjust = -0.15;
                  posiadjustmentx = 0.06;
                  corner1y = -0.2;
                  corner2y = -0.5;
                  facialadjust1x = -0.3;
                  facialadjust2x = -0.2;
                  floorpos = 0.2;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.94;
                }
                if (lengthy2 >= 110 && lengthy2 < 111) {
                  feet1adjust = -0.2;
                  feet2adjust = 0;
                  picketadjust = 0.8;
                  botadjust = -1.0;
                  topadjust = 0;
                  posiadjustmentx = 0.05;
                  corner1y = -0.7;
                  corner2y = 0.2;
                  facialadjust1x = 0.3;
                  facialadjust2x = -0;
                  floorpos = 0.3;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.93;
                }
                if (lengthy2 >= 111 && lengthy2 < 112) {
                  feet1adjust = -0.25;
                  feet2adjust = -0.1;
                  picketadjust = 1.1;
                  botadjust = -1.0;
                  topadjust = 0.1;
                  posiadjustmentx = 0.03;
                  corner1y = -1.1;
                  corner2y = 0.8;
                  facialadjust1x = 0.8;
                  facialadjust2x = 0.4;
                  floorpos = 0.3;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.93;
                }
                if (lengthy2 >= 112 && lengthy2 < 113) {
                  feet1adjust = -0.3;
                  feet2adjust = -0.15;
                  picketadjust = 1.4;
                  botadjust = -0.7;
                  topadjust = 0.2;
                  posiadjustmentx = 0.0;
                  corner1y = -1.2;
                  corner2y = 1.6;
                  facialadjust1x = 1.3;
                  facialadjust2x = 0.8;
                  floorpos = 0.3;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.93;
                }
                if (lengthy2 >= 113 && lengthy2 < 114) {
                  feet1adjust = -0.4;
                  feet2adjust = -0.2;
                  picketadjust = 1.6;
                  botadjust = -0.6;
                  topadjust = 0.3;
                  posiadjustmentx = 0.02;
                  corner1y = -2.1;
                  corner2y = 2;
                  facialadjust1x = 1.8;
                  facialadjust2x = 1.2;
                  floorpos = 0.4;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.93;
                }
                if (lengthy2 >= 114 && lengthy2 < 115) {
                  feet1adjust = -0.5;
                  feet2adjust = -0.25;
                  picketadjust = 1.8;
                  botadjust = -0.5;
                  topadjust = 0.4;
                  posiadjustmentx = 0.0;
                  corner1y = -2.2;
                  corner2y = 2.6;
                  facialadjust1x = 2.3;
                  facialadjust2x = 1.6;
                  floorpos = 0.5;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.93;
                }
                if (lengthy2 >= 115 && lengthy2 < 116) {
                  feet1adjust = -0.55;
                  feet2adjust = -0.35;
                  picketadjust = 2.3;
                  botadjust = -0.4;
                  topadjust = 0.5;
                  posiadjustmentx = -0.04;
                  corner1y = -2.5;
                  corner2y = 3.3;
                  facialadjust1x = 2.9;
                  facialadjust2x = 2;
                  floorpos = 0.5;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.93;
                }
                if (lengthy2 >= 116 && lengthy2 < 117) {
                  feet1adjust = -0.6;
                  feet2adjust = -0.45;
                  picketadjust = 2.8;
                  botadjust = -0.3;
                  topadjust = 0.6;
                  posiadjustmentx = -0.06;
                  corner1y = -2.5;
                  corner2y = 4.1;
                  facialadjust1x = 3.3;
                  facialadjust2x = 2.4;
                  floorpos = 0.6;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.91;
                }
                if (lengthy2 >= 117 && lengthy2 < 118) {
                  feet1adjust = -0.7;
                  feet2adjust = -0.55;
                  picketadjust = 3;
                  botadjust = -0.3;
                  topadjust = 0.6;
                  posiadjustmentx = -0.06;
                  corner1y = -2.7;
                  corner2y = 4.8;
                  facialadjust1x = 3.8;
                  facialadjust2x = 2.8;
                  floorpos = 0.7;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.91;
                }
                if (lengthy2 >= 118 && lengthy2 < 119) {
                  feet1adjust = -0.75;
                  feet2adjust = -0.7;
                  picketadjust = 3.3;
                  botadjust = -0.1;
                  topadjust = 0.7;
                  posiadjustmentx = -0.06;
                  corner1y = -2.9;
                  corner2y = 5.5;
                  facialadjust1x = 4.3;
                  facialadjust2x = 3.2;
                  floorpos = 0.75;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.91;
                }
                if (lengthy2 >= 119 && lengthy2 < 120) {
                  feet1adjust = -0.8;
                  feet2adjust = -0.8;
                  picketadjust = 3.7;
                  botadjust = 0;
                  topadjust = 0.8;
                  posiadjustmentx = -0.08;
                  corner1y = -3.5;
                  corner2y = 6;
                  facialadjust1x = 4.9;
                  facialadjust2x = 3.6;
                  floorpos = 0.8;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.91;
                }
                if (lengthy2 >= 120) {
                  feet1adjust = -0.9;
                  feet2adjust = -0.9;
                  picketadjust = 5;
                  botadjust = 0.1;
                  topadjust = 0.9;
                  corner1y = -3.6;
                  posiadjustmentx = -0.09;
                  corner2y = 6.5;
                  facialadjust1x = 5.5;
                  facialadjust2x = 4;
                  floorpos = 0.8;
                  floorscale = floorscale - 0.02;
                  cornerspecialadjust = -0.1;
                  measureadjust = 1.9;
                  topperadjust = 5.9;
                }

                topperadjust = -36 + (41.2 / 70) * divy;
              }
              klammerrechts = corner1y;
              klammerlinks = corner2y;
              lastadjust = measureadjust;

              let alignadjust = -7.2;
              if (props.form == 'l' && topmount) {
                floorscale = floorscale - 0.07;
                if (lengthy2 < 800) {
                  floorscale = floorscale - 0.02;
                }
              }
              let lengthytop1 = parseInt(props.len2) + 140;
              let lengthytop2 = parseInt(props.len2) + 70;

              if (para.count == 'en-us' || para.count == 'es-us') {
                lengthytop1 = parseFloat(props.len2 / 25.4 + 140 / 25.4).toFixed(2);
                lengthytop2 = parseFloat(props.len2 / 25.4 + 70 / 25.4).toFixed(2);
              }

              if (pointies2.length <= 2 && topmount) {
                floorpos = floorpos + ((parseInt(lengthy2) - 50) * -0.004285741 + 4.3);
              }
              if (topmount && props.form == 'l' && pointies2.length <= 2) {
                //floorscale = 0.4
                floorscale = 0 + (parseInt(lengthy2) - 50) * 0.0085 + 0.4;
                if (lengthy2 >= 100) {
                  floorscale = floorscale + 0.011;
                }
              }
              if (topmount && props.form == 'l' && pointies2.length > 2) {
                floorscale = floorscale - 0.08;
                floorpos = floorpos - 10;
              }

              return (
                <>
                  <group
                    {...props}
                    dispose={null}
                    scale={[0.1, 0.1, 0.1]}
                    position={[midpoint[1] + posiadjustmentx, 0, midpoint[0]]}
                    rotation-y={angle}
                  >
                    <group position={[3.19, 44.74, 8.66]}>
                      <group position={[0.89, 23.76, -35.14 - picketadjust]}>{picketadd(scaler, singlelength2)}</group>
                      <group visible={straighthandlauf} position={[0.86, 74.24, 8.64]}>
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_MOD5950_normal.geometry}
                          position={[0, heightmove, topadjust]}
                          scale={[handscalex, 1, handscaley]}
                          material={materials['physi alu']}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_MOD5950_normal_Corner_R.geometry}
                          visible={initialhandr}
                          position={[corner1x, heightmove, corner1y]}
                          material={materials['physi alu']}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_MOD5950_normal_Corner_L.geometry}
                          visible={initialhandl}
                          position={[corner2x, heightmove, corner2y]}
                          material={materials['physi alu']}
                        />
                      </group>
                      <group visible={bevelhandlauf} position={[0.86, 74.24, 8.64]}>
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_bevel.geometry}
                          position={[0, heightmove, topadjust]}
                          scale={[handscalex, 1, handscaley]}
                          material={materials['physi alu']}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_bevel_Corner_L.geometry}
                          visible={initialhandl}
                          position={[corner2x, heightmove, corner2y]}
                          material={materials['physi alu']}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_bevel_Corner_R.geometry}
                          visible={initialhandr}
                          position={[corner1x, heightmove, corner1y]}
                          material={materials['physi alu']}
                        />
                      </group>
                      <group visible={true} position={[0.86, 75.54, 8.68]} rotation={[0, 1.57, 0]}>
                        {klammerrender(2)}
                        <mesh
                          visible={false}
                          geometry={nodes.Handrail_Connector_normal_R.geometry}
                          material={materials['physi alu']}
                          position={[56.02, 0 + heightmove, 0]}
                        />
                        <mesh
                          visible={false}
                          geometry={nodes.Handrail_Connector_bevel_R.geometry}
                          material={materials['physi alu']}
                          position={[56.02 + topperadjust, 0 + heightmove, 0]}
                        />
                        <mesh
                          visible={false}
                          geometry={nodes.Handrail_Connector_normal_L.geometry}
                          material={materials['physi alu']}
                          position={[-56.02 - topperadjust, 0 + heightmove, 0]}
                        />
                        <mesh
                          visible={false}
                          geometry={nodes.Handrail_Connector_bevel_L.geometry}
                          material={materials['physi alu']}
                          position={[-56.02 - topperadjust, 0 + heightmove, 0]}
                        />
                      </group>
                      <group visible={true} position={[0.61, 75.56 + heightmove, 8.63]}>
                        <mesh
                          visible={klammerrvis}
                          geometry={nodes.Handrail_Corner_Connector_normal_R.geometry}
                          material={materials['physi alu']}
                          position={[0, 0, -60.49 + klammerrechts]}
                          rotation={[-Math.PI, Math.PI / 4, -Math.PI]}
                        />
                        <mesh
                          visible={klammerrvis2}
                          geometry={nodes.Handrail_Corner_Connector_bevel_R.geometry}
                          material={materials['physi alu']}
                          position={[0, 0, -60.49 + klammerrechts]}
                          rotation={[-Math.PI, Math.PI / 4, -Math.PI]}
                        />
                        <mesh
                          visible={klammerlvis}
                          geometry={nodes.Handrail_Corner_Connector_normal_L.geometry}
                          material={materials['physi alu']}
                          position={[0, 0, 60.49 + klammerlinks]}
                          rotation={[0, Math.PI / 4, 0]}
                        />
                        <mesh
                          visible={klammerlvis2}
                          geometry={nodes.Handrail_Corner_Connector_bevel_L.geometry}
                          material={materials['physi alu']}
                          position={[0, 0, 60.49 + klammerlinks]}
                          rotation={[0, Math.PI / 4, 0]}
                        />
                      </group>
                      <group position={[-4.68, -33.65, 6.16]} visible={topmount} rotation={[0, 1.57, 0]}>
                        <mesh
                          geometry={nodes.Easy_Alu_Feet_Corner_L.geometry}
                          visible={finalcornerr}
                          material={materials['physi alu']}
                          position={[-56.19 * scaler + feet1adjust, 1.64, 5.62]}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Feet_Corner_R.geometry}
                          visible={finalcornerl}
                          material={materials['physi alu']}
                          position={[51.15 * scaler + feet2adjust + cornerspecialadjust, 1.64, 5.62]}
                          rotation={[0, 0, -Math.PI]}
                        />
                        <mesh
                          geometry={nodes.Feet_L.geometry}
                          visible={initialcornerr}
                          material={materials['physi alu']}
                          position={[-56.64 * scaler + feet1adjust, -0.03, 2.19]}
                        />
                        <mesh
                          geometry={nodes.Feet_R.geometry}
                          visible={initialcornerl}
                          material={materials['physi alu']}
                          position={[56.64 * scaler + feet2adjust, 0.03, -2.19]}
                        />
                      </group>
                      <group position={[0.8, -43.86, -45.03]} visible={facial} rotation={[0, -1.57, 0]}>
                        <mesh
                          geometry={nodes.Feet_Fascia_L.geometry}
                          material={materials['physi alu']}
                          position={[107.41 + facialadjust1x, 11.86, -0.01]}
                          rotation={[0, 0, -Math.PI]}
                        />
                        <mesh
                          visible={facialplate2}
                          geometry={nodes.Feet_Adapter_Fascia_L.geometry}
                          material={materials['physi alu']}
                          position={[99.21 + facialadjust1x, 5.86, 2.63]}
                          rotation={[Math.PI, -1.57, 0]}
                        />
                        <mesh
                          geometry={nodes.Feet_Fascia_R.geometry}
                          material={materials['physi alu']}
                          position={[0.1 - facialadjust2x, -0.14, -0.08]}
                        />
                        <mesh
                          visible={facialplate1}
                          geometry={nodes.Feet_Adapter_Fascia_R.geometry}
                          material={materials['physi alu']}
                          position={[8.3 - facialadjust2x, 5.86, 2.63]}
                          rotation={[0, 1.57, 0]}
                        />
                      </group>
                      <mesh
                        geometry={nodes.Easy_Alu_frame_down.geometry}
                        material={materials['physi alu']}
                        scale={[1, 1 * scaler, 1]}
                        position={[0.75, -26.49, 9.11 + botadjust]}
                        rotation={[Math.PI / 2, 0, 0]}
                      />
                      <mesh
                        geometry={nodes.Easy_Alu_frame_R.geometry}
                        material={materials['physi alu']}
                        position={[0.77, 21.18 + heightmove / 2, -45.02 * scaler]}
                        scale={[1, heightscaler, 1]}
                      />
                      <mesh
                        geometry={nodes.Easy_Alu_frame_L.geometry}
                        material={materials['physi alu']}
                        position={[0.77, 21.18 + heightmove / 2, 62.39 * scaler]}
                        scale={[1, heightscaler, 1]}
                      />
                      <mesh
                        visible={false}
                        geometry={nodes.Glass.geometry}
                        material={materials['Glass Frosted']}
                        position={[0.65, 23.97, 8.66]}
                      />
                      <mesh
                        visible={topmount}
                        geometry={nodes.Floor_TOP.geometry}
                        material={materials['physi concrete']}
                        scale={[1, 1, floorscale]}
                        position={[-3.19 + alignadjust, -39.62, 8.66 + floorpos]}
                      />
                      <mesh
                        visible={facial}
                        geometry={nodes.Floor_Fascia.geometry}
                        material={materials['physi concrete']}
                        scale={[1, 1, floorscale]}
                        position={[-17.84, -38.01, 8.66 + floorpos]}
                      />
                    </group>
                  </group>
                  {props.form == 'u' && topmount && (
                    <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                      <Line
                        points={[
                          [0.3, -4, 0.241],
                          [pointies2[pointies2.length - 1][1] + measureadjust + 0.3, -4, 0.241],
                        ]}
                      />
                      <Line
                        points={[
                          [pointies2[pointies2.length - 1][1] + measureadjust + 0.3, -4.5, 0.241],
                          [pointies2[pointies2.length - 1][1] + measureadjust + 0.3],
                          -1.5,
                          0.241,
                        ]}
                        dashed={false}
                      />
                      {facial && (
                        <Text
                          color={'black'}
                          position={[(pointies2[0][1] + pointies2[pointies2.length - 1][1]) / 2, -5 + textup, 0]}
                          rotation-y={props.polarcoord}
                          scale={textscale}
                        >
                          B :{' '}
                          {para.count == 'en-us' || para.count == 'es-us' ? lengthytop1 + ' "' : lengthytop1 + ' mm'}
                        </Text>
                      )}
                      {topmount && (
                        <Text
                          color={'black'}
                          position={[(pointies2[0][1] + pointies2[pointies2.length - 1][1]) / 2, -5 + textup, 0]}
                          rotation-y={props.polarcoord}
                          scale={textscale}
                        >
                          B :{' '}
                          {para.count != ('en-us' || 'es-us')
                            ? props.len2 + ' mm'
                            : parseFloat(props.len2 / 25.4).toFixed(2) + ' "'}
                        </Text>
                      )}

                      <Cone
                        position={[pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.2, -4, 0.241]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-x={Math.PI / 2}
                        rotation-z={-Math.PI / 2}
                      />
                      <Cone
                        position={[0.3 + 0.2, -4, 0.241]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-x={Math.PI / 2}
                        rotation-z={Math.PI / 2}
                      />
                    </group>
                  )}

                  {props.form == 'u' && facial && (
                    <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                      <Line
                        points={[
                          [0.3 + 0.72, -5, 0.241 + 0.72],
                          [pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.72, -5, 0.241 + 0.72],
                        ]}
                      />
                      <Line
                        points={[
                          [pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.72, -0.5, 0.241 + 0.72],
                          [pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.72],
                          -5.5,
                          0.241 + 0.72,
                        ]}
                        dashed={false}
                      />
                      <Text
                        color={'black'}
                        position={[(pointies2[0][1] + pointies2[pointies2.length - 1][1]) / 2, -6 - textup - 1, 0.73]}
                        rotation-y={props.polarcoord}
                        scale={textscale}
                      >
                        B :{' '}
                        {para.count != ('en-us' || 'es-us')
                          ? props.len2 + ' mm'
                          : parseFloat(props.len2 / 25.4).toFixed(2) + ' "'}
                      </Text>
                      <Cone
                        position={[
                          pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.72,
                          -5,
                          0.241 + 0.72,
                        ]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-x={Math.PI / 2}
                        rotation-z={-Math.PI / 2}
                      />
                      <Cone
                        position={[0.3 + 0.2 + 0.72, -5, 0.241 + 0.72]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-x={Math.PI / 2}
                        rotation-z={Math.PI / 2}
                      />
                    </group>
                  )}

                  {props.form == 'l' && topmount && (
                    <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                      <Line
                        points={[
                          [0.3, -4, 0.241],
                          [pointies2[pointies2.length - 1][1] + measureadjust - 0.55, -4, 0.241],
                        ]}
                      />
                      <Line
                        points={[
                          [pointies2[pointies2.length - 1][1] + measureadjust - 0.55, -4.5, 0.241],
                          [pointies2[pointies2.length - 1][1] + measureadjust - 0.55],
                          -1.5,
                          0.241,
                        ]}
                        dashed={false}
                      />
                      {facial && (
                        <Text
                          color={'black'}
                          position={[(pointies2[0][1] + pointies2[pointies2.length - 1][1]) / 2, -5 + textup, 0]}
                          rotation-y={props.polarcoord}
                          scale={textscale}
                        >
                          B :{' '}
                          {para.count == 'en-us' || para.count == 'es-us' ? lengthytop2 + ' "' : lengthytop2 + ' mm'}
                        </Text>
                      )}
                      {topmount && (
                        <Text
                          color={'black'}
                          position={[(pointies2[0][1] + pointies2[pointies2.length - 1][1]) / 2, -5 + textup, 0]}
                          rotation-y={props.polarcoord}
                          scale={textscale}
                        >
                          B :{' '}
                          {para.count != ('en-us' || 'es-us')
                            ? props.len2 + ' mm'
                            : parseFloat(props.len2 / 25.4).toFixed(2) + ' "'}
                        </Text>
                      )}
                      <Cone
                        position={[pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.83, -4, 0.241]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-x={Math.PI / 2}
                        rotation-z={-Math.PI / 2}
                      />
                      <Cone
                        position={[0.3 + 0.2, -4, 0.241]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-x={Math.PI / 2}
                        rotation-z={Math.PI / 2}
                      />
                    </group>
                  )}

                  {props.form == 'l' && facial && (
                    <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                      <Line
                        points={[
                          [0.3 + 0.72, -5, 0.241 + 0.72],
                          [pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.72 - 0.2, -5, 0.241 + 0.72],
                        ]}
                      />
                      <Line
                        points={[
                          [pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.72 - 0.2, -0.5, 0.241 + 0.72],
                          [pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.72 - 0.2],
                          -5.5,
                          0.241 + 0.72,
                        ]}
                        dashed={false}
                      />
                      <Text
                        color={'black'}
                        position={[(pointies2[0][1] + pointies2[pointies2.length - 1][1]) / 2, -6 - textup - 1, 0.73]}
                        rotation-y={props.polarcoord}
                        scale={textscale}
                      >
                        B :{' '}
                        {para.count != ('en-us' || 'es-us')
                          ? props.len2 + ' mm'
                          : parseFloat(props.len2 / 25.4).toFixed(2) + ' "'}
                      </Text>
                      <Cone
                        position={[
                          pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.72 - 0.2,
                          -5,
                          0.241 + 0.72,
                        ]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-x={Math.PI / 2}
                        rotation-z={-Math.PI / 2}
                      />
                      <Cone
                        position={[0.3 + 0.2 + 0.72, -5, 0.241 + 0.72]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-x={Math.PI / 2}
                        rotation-z={Math.PI / 2}
                      />
                    </group>
                  )}

                  {props.wall2 && props.form == 'l' && wallrender(measureadjust, 3, lastadjust)}
                </>
              );
            }
          })}

        {props.form == 'u' &&
          pointies3.map((item, index) => {
            let angle = Math.PI / 2 + (Math.PI * 3) / 2;
            if (index < pointies3.length - 1) {
              let currentCoord = item;
              let nextCoord = pointies3[index + 1];
              let scaler = singlelength3 / 11;

              let midpoint = [(currentCoord[0] + nextCoord[0]) / 2, (currentCoord[1] + nextCoord[1]) / 2];

              let lengthy2 = singlelength3 * 10;
              let handscalex = 1;
              let handscaley = scaler;
              let picketadjust = 0;
              let feet1adjust = 0;
              let feet2adjust = 0;
              let topadjust = 0;
              let botadjust = 0;
              let facialplate1 = false;
              let measureadjust = 0;
              let cornerposx = 0;
              let cornerposy = 0;
              let completeadjustx = 1.875;
              let completeadjusty = -1.1;
              let initialcornerr = true;
              let finalcornerr = false;
              let facialadjust1x = 0;
              let facialadjust2x = 0;
              let initializator = 1;
              let floorscale = scaler;
              let floorpos = 0;
              let firstadjust = 0;
              let heightscaler = 1;
              let heightmove = 0;
              let alignadjust = -7.2;
              let alignadjustscale = -0.129;
              let topperadjust = 0;
              let divy = Math.abs(50 - lengthy2);

              if (props.hohe == 900) {
                heightscaler = 100 / 110;
                heightmove = -10;
              }
              if (props.hohe == 1000) {
                heightscaler = 105 / 110;
                heightmove = -5;
              }
              if (props.hohe == 1100) {
                heightscaler = 1;
                heightmove = 0;
              }
              /*TOMORRW cornerposy ; completeadjust; feet2adjust von 84-end*/
              if (initializator == 1) {
                if (lengthy2 >= 50 && lengthy2 < 51) {
                  feet1adjust = 1.5;
                  feet2adjust = 3.7;
                  picketadjust = -24.5;
                  botadjust = -5;
                  topadjust = -4.7;
                  cornerposy = -23.7;
                  facialadjust1x = -34.1;
                  facialadjust2x = -24.6;
                  floorpos = -5;
                  floorscale = floorscale - 0.0615;
                  completeadjusty = -0.96;
                  completeadjustx = 1.96;
                  measureadjust = 1.33;
                  topperadjust = -35.7;
                }
                if (lengthy2 >= 51 && lengthy2 < 52) {
                  feet1adjust = 1.3;
                  feet2adjust = 3.5;
                  picketadjust = -24.3;
                  botadjust = -5;
                  topadjust = -4.7;
                  cornerposy = -23.8;
                  facialadjust1x = -33.5;
                  facialadjust2x = -24.3;
                  floorpos = -5;
                  floorscale = floorscale - 0.068;
                  completeadjusty = -1;
                  completeadjustx = 2;
                  measureadjust = 1.31;
                }
                if (lengthy2 >= 52 && lengthy2 < 53) {
                  feet1adjust = 1.3;
                  feet2adjust = 3.4;
                  picketadjust = -24.1;
                  botadjust = -5;
                  topadjust = -4.7;
                  cornerposy = -24;
                  facialadjust1x = -33;
                  facialadjust2x = -23.8;
                  floorpos = -4.75;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.04;
                  completeadjustx = 2.02;
                  measureadjust = 1.28;
                }
                if (lengthy2 >= 53 && lengthy2 < 54) {
                  feet1adjust = 1.4;
                  feet2adjust = 3.4;
                  picketadjust = -24.1;
                  botadjust = -5;
                  topadjust = -4.5;
                  cornerposy = -23.2;
                  facialadjust1x = -32.3;
                  facialadjust2x = -23.3;
                  floorpos = -4.7;
                  floorscale = floorscale - 0.068;
                  completeadjusty = -1.02;
                  completeadjustx = 2;
                  measureadjust = 1.28;
                }
                if (lengthy2 >= 54 && lengthy2 < 55) {
                  feet1adjust = 1.5;
                  feet2adjust = 3.2;
                  picketadjust = -23.8;
                  botadjust = -5;
                  topadjust = -4.4;
                  cornerposy = -22.9;
                  facialadjust1x = -31.5;
                  facialadjust2x = -23;
                  floorpos = -4.65;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.04;
                  completeadjustx = 2;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 55 && lengthy2 < 56) {
                  feet1adjust = 1.5;
                  feet2adjust = 3.1;
                  picketadjust = -23.2;
                  botadjust = -5;
                  topadjust = -4.4;
                  cornerposy = -22.5;
                  facialadjust1x = -31;
                  facialadjust2x = -22.6;
                  floorpos = -4.6;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.05;
                  completeadjustx = 2;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 56 && lengthy2 < 57) {
                  feet1adjust = 1.6;
                  feet2adjust = 3.1;
                  picketadjust = -23;
                  botadjust = -5;
                  topadjust = -4.3;
                  cornerposy = -22;
                  facialadjust1x = -30.6;
                  facialadjust2x = -22;
                  floorpos = -4.5;
                  floorscale = floorscale - 0.078;
                  completeadjusty = -1.09;
                  completeadjustx = 1.99;
                  measureadjust = 1.27;
                }
                if (lengthy2 >= 57 && lengthy2 < 58) {
                  feet1adjust = 1.65;
                  feet2adjust = 3.1;
                  picketadjust = -22.9;
                  botadjust = -5.1;
                  topadjust = -4.2;
                  cornerposy = -21;
                  facialadjust1x = -30.1;
                  facialadjust2x = -21.6;
                  floorpos = -4.5;
                  floorscale = floorscale - 0.062;
                  completeadjusty = -1.01;
                  completeadjustx = 1.96;
                  measureadjust = 1.29;
                }
                if (lengthy2 >= 58 && lengthy2 < 59) {
                  feet1adjust = 1.4;
                  feet2adjust = 3;
                  picketadjust = -22.1;
                  botadjust = -5.1;
                  topadjust = -4.1;
                  cornerposy = -21;
                  facialadjust1x = -29.6;
                  facialadjust2x = -21.2;
                  floorpos = -4.4;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.07;
                  completeadjustx = 1.96;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 59 && lengthy2 < 60) {
                  feet1adjust = 1.2;
                  feet2adjust = 2.8;
                  picketadjust = -21.8;
                  botadjust = -5.1;
                  topadjust = -4;
                  cornerposy = -20.7;
                  facialadjust1x = -29;
                  facialadjust2x = -20.9;
                  floorpos = -4.4;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.09;
                  completeadjustx = 1.96;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 60 && lengthy2 < 61) {
                  feet1adjust = 1.1;
                  feet2adjust = 2.7;
                  picketadjust = -20.5;
                  botadjust = -5.1;
                  topadjust = -4;
                  cornerposy = -20.4;
                  facialadjust1x = -28.5;
                  facialadjust2x = -20.3;
                  floorpos = -4.35;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.095;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 61 && lengthy2 < 62) {
                  feet1adjust = 1.1;
                  feet2adjust = 2.65;
                  picketadjust = -20.3;
                  botadjust = -5;
                  topadjust = -3.95;
                  cornerposy = -20;
                  facialadjust1x = -28;
                  facialadjust2x = -20.1;
                  floorpos = -4.2;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.1;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 62 && lengthy2 < 63) {
                  feet1adjust = 1.0;
                  feet2adjust = 2.6;
                  picketadjust = -20.1;
                  botadjust = -5;
                  topadjust = -3.9;
                  cornerposy = -19.5;
                  facialadjust1x = -27.5;
                  facialadjust2x = -19.7;
                  floorpos = -4.1;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.096;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 63 && lengthy2 < 64) {
                  feet1adjust = 1.0;
                  feet2adjust = 2.55;
                  picketadjust = -19.9;
                  botadjust = -5;
                  topadjust = -3.8;
                  cornerposy = -19.1;
                  facialadjust1x = -26.8;
                  facialadjust2x = -19.4;
                  floorpos = -4.0;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.12;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 64 && lengthy2 < 65) {
                  feet1adjust = 0.9;
                  feet2adjust = 2.5;
                  picketadjust = -19.8;
                  botadjust = -4.9;
                  topadjust = -3.7;
                  cornerposy = -18.6;
                  facialadjust1x = -26.3;
                  facialadjust2x = -19.0;
                  floorpos = -3.9;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.13;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 65 && lengthy2 < 66) {
                  feet1adjust = 0.8;
                  feet2adjust = 2.45;
                  picketadjust = -19.5;
                  botadjust = -4.8;
                  topadjust = -3.6;
                  cornerposy = -18;
                  facialadjust1x = -25.7;
                  facialadjust2x = -18.5;
                  floorpos = -3.8;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.1;
                  completeadjustx = 1.97;
                  measureadjust = 1.31;
                }
                if (lengthy2 >= 66 && lengthy2 < 67) {
                  feet1adjust = 0.8;
                  feet2adjust = 2.4;
                  picketadjust = -19.2;
                  botadjust = -4.7;
                  topadjust = -3.5;
                  cornerposy = -17.8;
                  facialadjust1x = -25.2;
                  facialadjust2x = -17.8;
                  floorpos = -3.7;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.15;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 67 && lengthy2 < 68) {
                  feet1adjust = 0.7;
                  feet2adjust = 2.3;
                  picketadjust = -18.8;
                  botadjust = -4.6;
                  topadjust = -3.4;
                  cornerposy = -17.3;
                  facialadjust1x = -24.6;
                  facialadjust2x = -17.6;
                  floorpos = -3.6;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.16;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 68 && lengthy2 < 69) {
                  feet1adjust = 0.6;
                  feet2adjust = 2.2;
                  picketadjust = -18.7;
                  botadjust = -4.6;
                  topadjust = -3.2;
                  cornerposy = -17;
                  facialadjust1x = -24.0;
                  facialadjust2x = -17;
                  floorpos = -3.5;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.17;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 69 && lengthy2 < 70) {
                  feet1adjust = 0.5;
                  feet2adjust = 2.15;
                  picketadjust = -18.5;
                  botadjust = -4.4;
                  topadjust = -3.0;
                  cornerposy = -16.9;
                  facialadjust1x = -23.3;
                  facialadjust2x = -16.9;
                  floorpos = -3.4;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.17;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 70 && lengthy2 < 71) {
                  feet1adjust = 0.6;
                  feet2adjust = 2.1;
                  picketadjust = -16.5;
                  botadjust = -4.4;
                  topadjust = -3.2;
                  cornerposy = -16.35;
                  facialadjust1x = -22.9;
                  facialadjust2x = -16.5;
                  floorpos = -3.3;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.17;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 71 && lengthy2 < 72) {
                  feet1adjust = 0.4;
                  feet2adjust = 2;
                  picketadjust = -15.8;
                  botadjust = -4.2;
                  topadjust = -3.1;
                  cornerposy = -15.8;
                  facialadjust1x = -22.3;
                  facialadjust2x = -16.1;
                  floorpos = -3.2;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.17;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 72 && lengthy2 < 73) {
                  feet1adjust = 0.4;
                  feet2adjust = 1.9;
                  picketadjust = -15.4;
                  botadjust = -4.1;
                  topadjust = -3.0;
                  cornerposy = -15.6;
                  facialadjust1x = -21.8;
                  facialadjust2x = -15.6;
                  floorpos = -3.1;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.2;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 73 && lengthy2 < 74) {
                  feet1adjust = 0.37;
                  feet2adjust = 1.8;
                  picketadjust = -15.2;
                  botadjust = -4.1;
                  topadjust = -3.0;
                  cornerposy = -15.2;
                  facialadjust1x = -21.2;
                  facialadjust2x = -15.1;
                  floorpos = -3;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.21;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 74 && lengthy2 < 75) {
                  feet1adjust = 0.3;
                  feet2adjust = 1.75;
                  picketadjust = -14.8;
                  botadjust = -3.9;
                  topadjust = -2.8;
                  cornerposy = -14.6;
                  facialadjust1x = -20.7;
                  facialadjust2x = -14.7;
                  floorpos = -2.8;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.23;
                  completeadjustx = 1.98;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 75 && lengthy2 < 76) {
                  feet1adjust = 0.3;
                  feet2adjust = 1.7;
                  picketadjust = -14.6;
                  botadjust = -3.7;
                  topadjust = -2.8;
                  cornerposy = -14.1;
                  facialadjust1x = -20.1;
                  facialadjust2x = -14.2;
                  floorpos = -2.7;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.25;
                  completeadjustx = 1.98;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 76 && lengthy2 < 77) {
                  feet1adjust = 0.3;
                  feet2adjust = 1.65;
                  picketadjust = -14.4;
                  botadjust = -3.6;
                  topadjust = -2.6;
                  cornerposy = -13.9;
                  facialadjust1x = -19.5;
                  facialadjust2x = -13.8;
                  floorpos = -2.6;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.25;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 77 && lengthy2 < 78) {
                  feet1adjust = 0.2;
                  feet2adjust = 1.6;
                  picketadjust = -14.8;
                  botadjust = -3.5;
                  topadjust = -2.4;
                  cornerposy = -13.6;
                  facialadjust1x = -19.1;
                  facialadjust2x = -13.4;
                  floorpos = -2.5;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.27;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 78 && lengthy2 < 79) {
                  feet1adjust = -0.1;
                  feet2adjust = 1.5;
                  picketadjust = -14.3;
                  botadjust = -3.5;
                  topadjust = -2.4;
                  cornerposy = -13.1;
                  facialadjust1x = -18.5;
                  facialadjust2x = -13;
                  floorpos = -2.3;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.28;
                  completeadjustx = 1.96;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 79 && lengthy2 < 80) {
                  feet1adjust = -0.2;
                  feet2adjust = 1.45;
                  picketadjust = -14.1;
                  botadjust = -3.5;
                  topadjust = -2.4;
                  cornerposy = -12.8;
                  facialadjust1x = -17.9;
                  facialadjust2x = -12.6;
                  floorpos = -2.2;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.29;
                  completeadjustx = 1.97;
                  measureadjust = 1.28;
                }
                if (lengthy2 >= 80 && lengthy2 < 81) {
                  feet1adjust = -0.3;
                  feet2adjust = 1.4;
                  picketadjust = -12.3;
                  botadjust = -3.2;
                  topadjust = -2.1;
                  cornerposy = -12.6;
                  facialadjust1x = -17.3;
                  facialadjust2x = -12.1;
                  floorpos = -2.1;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.3;
                  completeadjustx = 1.97;
                  measureadjust = 1.28;
                }
                if (lengthy2 >= 81 && lengthy2 < 82) {
                  feet1adjust = -0.4;
                  feet2adjust = 1.3;
                  picketadjust = -11.9;
                  botadjust = -3.1;
                  topadjust = -2.0;
                  cornerposy = -12.3;
                  facialadjust1x = -16.4;
                  facialadjust2x = -11.7;
                  floorpos = -2;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.31;
                  completeadjustx = 1.97;
                  measureadjust = 1.28;
                }
                if (lengthy2 >= 82 && lengthy2 < 83) {
                  feet1adjust = -0.2;
                  feet2adjust = 1.2;
                  picketadjust = -11.7;
                  botadjust = -3.1;
                  topadjust = -2.3;
                  cornerposy = -12;
                  facialadjust1x = -15.8;
                  facialadjust2x = -11.2;
                  floorpos = -1.9;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.32;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 83 && lengthy2 < 84) {
                  feet1adjust = -0.2;
                  feet2adjust = 1.15;
                  picketadjust = -11.5;
                  botadjust = -3.1;
                  topadjust = -2.3;
                  cornerposy = -11.5;
                  facialadjust1x = -15.2;
                  facialadjust2x = -10.8;
                  floorpos = -1.8;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.33;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 84 && lengthy2 < 85) {
                  feet1adjust = -0.2;
                  feet2adjust = 1;
                  picketadjust = -11.1;
                  botadjust = -3;
                  topadjust = -2;
                  cornerposy = -11.3;
                  facialadjust1x = -14.6;
                  facialadjust2x = -10.45;
                  floorpos = -1.7;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.35;
                  completeadjustx = 1.97;
                  measureadjust = 1.26;
                }
                if (lengthy2 >= 85 && lengthy2 < 86) {
                  feet1adjust = -0.2;
                  feet2adjust = 1.1;
                  picketadjust = -10.8;
                  botadjust = -2.9;
                  topadjust = -1.9;
                  cornerposy = -11;
                  facialadjust1x = -14.1;
                  facialadjust2x = -10.1;
                  floorpos = -1.6;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.37;
                  completeadjustx = 1.97;
                  measureadjust = 1.25;
                }
                if (lengthy2 >= 86 && lengthy2 < 87) {
                  feet1adjust = -0.2;
                  feet2adjust = 1.05;
                  picketadjust = -10.5;
                  botadjust = -2.9;
                  topadjust = -1.9;
                  cornerposy = -10.5;
                  facialadjust1x = -13.8;
                  facialadjust2x = -9.6;
                  floorpos = -1.3;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.38;
                  completeadjustx = 1.97;
                  measureadjust = 1.24;
                }
                if (lengthy2 >= 87 && lengthy2 < 88) {
                  feet1adjust = -0.1;
                  feet2adjust = 1;
                  picketadjust = -10.2;
                  botadjust = -2.8;
                  topadjust = -1.8;
                  cornerposy = -10.3;
                  facialadjust1x = -13.2;
                  facialadjust2x = -9.2;
                  floorpos = -1.2;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.38;
                  completeadjustx = 1.97;
                  measureadjust = 1.24;
                }
                if (lengthy2 >= 88 && lengthy2 < 89) {
                  feet1adjust = -0.4;
                  feet2adjust = 0.95;
                  picketadjust = -10;
                  botadjust = -2.8;
                  topadjust = -1.8;
                  cornerposy = -10;
                  facialadjust1x = -12.8;
                  facialadjust2x = -8.9;
                  floorpos = -1.1;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.4;
                  completeadjustx = 1.97;
                  measureadjust = 1.24;
                }
                if (lengthy2 >= 89 && lengthy2 < 90) {
                  feet1adjust = -0.4;
                  feet2adjust = 0.95;
                  picketadjust = -9.8;
                  botadjust = -2.8;
                  topadjust = -1.8;
                  cornerposy = -9.6;
                  facialadjust1x = -12.1;
                  facialadjust2x = -8.5;
                  floorpos = -1;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.41;
                  completeadjustx = 1.97;
                  measureadjust = 1.24;
                }
                if (lengthy2 >= 90 && lengthy2 < 91) {
                  feet1adjust = -0.4;
                  feet2adjust = 0.95;
                  picketadjust = -7.8;
                  botadjust = -2.6;
                  topadjust = -1.7;
                  cornerposy = -8.9;
                  facialadjust1x = -11.6;
                  facialadjust2x = -8.1;
                  floorpos = -0.85;
                  floorscale = floorscale - 0.072;
                  completeadjusty = -1.4;
                  completeadjustx = 1.97;
                  measureadjust = 1.24;
                }
                if (lengthy2 >= 91 && lengthy2 < 92) {
                  feet1adjust = -0.4;
                  feet2adjust = 0.95;
                  picketadjust = -7.6;
                  botadjust = -2.6;
                  topadjust = -1.6;
                  cornerposy = -8.4;
                  facialadjust1x = -11;
                  facialadjust2x = -7.6;
                  floorpos = -0.7;
                  floorscale = floorscale - 0.07;
                  completeadjusty = -1.4;
                  completeadjustx = 1.97;
                  measureadjust = 1.25;
                }
                if (lengthy2 >= 92 && lengthy2 < 93) {
                  feet1adjust = -0.3;
                  feet2adjust = 0.9;
                  picketadjust = -6.7;
                  botadjust = -2.4;
                  topadjust = -1.5;
                  cornerposy = -7.8;
                  facialadjust1x = -10.5;
                  facialadjust2x = -7.2;
                  floorpos = -0.6;
                  floorscale = floorscale - 0.07;
                  completeadjusty = -1.4;
                  completeadjustx = 1.97;
                  measureadjust = 1.25;
                }
                if (lengthy2 >= 93 && lengthy2 < 94) {
                  feet1adjust = -0.3;
                  feet2adjust = 0.85;
                  picketadjust = -6.5;
                  botadjust = -2.3;
                  topadjust = -1.3;
                  cornerposy = -7.2;
                  facialadjust1x = -10;
                  facialadjust2x = -6.9;
                  floorpos = -0.5;
                  floorscale = floorscale - 0.07;
                  completeadjusty = -1.41;
                  completeadjustx = 1.97;
                  measureadjust = 1.25;
                }
                if (lengthy2 >= 94 && lengthy2 < 95) {
                  feet1adjust = -0.4;
                  feet2adjust = 0.85;
                  picketadjust = -6.2;
                  botadjust = -2.3;
                  topadjust = -1.3;
                  cornerposy = -6.7;
                  facialadjust1x = -9.3;
                  facialadjust2x = -6.5;
                  floorpos = -0.5;
                  floorscale = floorscale - 0.07;
                  completeadjusty = -1.41;
                  completeadjustx = 1.97;
                  measureadjust = 1.25;
                }
                if (lengthy2 >= 95 && lengthy2 < 96) {
                  feet1adjust = -0.4;
                  feet2adjust = 0.85;
                  picketadjust = -5.9;
                  botadjust = -2.2;
                  topadjust = -1.2;
                  cornerposy = -6.4;
                  facialadjust1x = -8.7;
                  facialadjust2x = -6.1;
                  floorpos = -0.7;
                  floorscale = floorscale - 0.074;
                  completeadjusty = -1.42;
                  completeadjustx = 1.97;
                  measureadjust = 1.25;
                }
                if (lengthy2 >= 96 && lengthy2 < 97) {
                  feet1adjust = -0.6;
                  feet2adjust = 0.8;
                  picketadjust = -5.2;
                  botadjust = -2.1;
                  topadjust = -1.1;
                  cornerposy = -6;
                  facialadjust1x = -8.1;
                  facialadjust2x = -5.8;
                  floorpos = -0.7;
                  floorscale = floorscale - 0.074;
                  completeadjusty = -1.42;
                  completeadjustx = 1.97;
                  measureadjust = 1.28;
                }
                if (lengthy2 >= 97 && lengthy2 < 98) {
                  feet1adjust = -0.7;
                  feet2adjust = 0.75;
                  picketadjust = -5.1;
                  botadjust = -2.1;
                  topadjust = -1.1;
                  cornerposy = -5.6;
                  facialadjust1x = -7.6;
                  facialadjust2x = -5.4;
                  floorpos = -0.65;
                  floorscale = floorscale - 0.074;
                  completeadjusty = -1.43;
                  completeadjustx = 1.97;
                  measureadjust = 1.28;
                }
                if (lengthy2 >= 98 && lengthy2 < 99) {
                  feet1adjust = -0.9;
                  feet2adjust = 0.75;
                  picketadjust = -4.7;
                  botadjust = -2.0;
                  topadjust = -0.9;
                  cornerposy = -5.1;
                  facialadjust1x = -7.0;
                  facialadjust2x = -5;
                  floorpos = -0.65;
                  floorscale = floorscale - 0.074;
                  completeadjusty = -1.43;
                  completeadjustx = 1.97;
                  measureadjust = 1.28;
                }
                if (lengthy2 >= 99 && lengthy2 < 100) {
                  feet1adjust = -0.8;
                  feet2adjust = 0.7;
                  picketadjust = -4.4;
                  botadjust = -2.0;
                  topadjust = -0.9;
                  cornerposy = -4.7;
                  facialadjust1x = -6.5;
                  facialadjust2x = -4.8;
                  floorpos = 0.5;
                  floorscale = floorscale - 0.058;
                  completeadjusty = -1.44;
                  completeadjustx = 1.97;
                  measureadjust = 1.28;
                }
                if (lengthy2 >= 100 && lengthy2 < 101) {
                  feet1adjust = -0.6;
                  feet2adjust = 0.65;
                  picketadjust = -2.9;
                  botadjust = -1.8;
                  topadjust = -0.7;
                  cornerposy = -4.2;
                  facialadjust1x = -5.8;
                  facialadjust2x = -4.4;
                  floorpos = -0.5;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.44;
                  completeadjustx = 1.97;
                  measureadjust = 1.29;
                }
                if (lengthy2 >= 101 && lengthy2 < 102) {
                  feet1adjust = -0.6;
                  feet2adjust = 0.65;
                  picketadjust = -2.7;
                  botadjust = -1.8;
                  topadjust = -0.7;
                  cornerposy = -3.8;
                  facialadjust1x = -5.1;
                  facialadjust2x = -4;
                  floorpos = -0.3;
                  floorscale = floorscale - 0.074;
                  completeadjusty = -1.45;
                  completeadjustx = 1.97;
                  measureadjust = 1.29;
                }
                if (lengthy2 >= 102 && lengthy2 < 103) {
                  feet1adjust = -0.8;
                  feet2adjust = 0.65;
                  picketadjust = -2.5;
                  botadjust = -1.7;
                  topadjust = -0.6;
                  cornerposy = -3.3;
                  facialadjust1x = -4.6;
                  facialadjust2x = -3.5;
                  floorpos = -0.2;
                  floorscale = floorscale - 0.074;
                  completeadjusty = -1.46;
                  completeadjustx = 1.97;
                  measureadjust = 1.29;
                }
                if (lengthy2 >= 103 && lengthy2 < 104) {
                  feet1adjust = -0.8;
                  feet2adjust = 0.65;
                  picketadjust = -2.2;
                  botadjust = -1.7;
                  topadjust = -0.6;
                  cornerposy = -2.9;
                  facialadjust1x = -4;
                  facialadjust2x = -3;
                  floorpos = -0.3;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.46;
                  completeadjustx = 1.97;
                  measureadjust = 1.29;
                }
                if (lengthy2 >= 104 && lengthy2 < 105) {
                  feet1adjust = -0.9;
                  feet2adjust = 0.55;
                  picketadjust = -1.9;
                  botadjust = -1.5;
                  topadjust = -0.35;
                  cornerposy = -2.3;
                  facialadjust1x = -3.4;
                  facialadjust2x = -2.5;
                  floorpos = -0.3;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.47;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 105 && lengthy2 < 106) {
                  feet1adjust = -1;
                  feet2adjust = 0.5;
                  picketadjust = -1.6;
                  botadjust = -1.4;
                  topadjust = -0.3;
                  cornerposy = -2;
                  facialadjust1x = -2.8;
                  facialadjust2x = -2.1;
                  floorpos = -0.2;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.47;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 106 && lengthy2 < 107) {
                  feet1adjust = -1.1;
                  feet2adjust = 0.45;
                  picketadjust = -1.3;
                  botadjust = -1.35;
                  topadjust = -0.25;
                  cornerposy = -1.5;
                  facialadjust1x = -2.1;
                  facialadjust2x = -1.6;
                  floorpos = -0.1;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.48;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 107 && lengthy2 < 108) {
                  feet1adjust = -1.2;
                  feet2adjust = 0.4;
                  picketadjust = -1;
                  botadjust = -1.3;
                  topadjust = -0.2;
                  cornerposy = -1;
                  facialadjust1x = -1.5;
                  facialadjust2x = -1.1;
                  floorpos = 0;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.48;
                  completeadjustx = 1.97;
                  measureadjust = 1.31;
                }
                if (lengthy2 >= 108 && lengthy2 < 109) {
                  feet1adjust = -1.2;
                  feet2adjust = 0.3;
                  picketadjust = -0.6;
                  botadjust = -1.2;
                  topadjust = -0.15;
                  cornerposy = -0.7;
                  facialadjust1x = -0.9;
                  facialadjust2x = -0.8;
                  floorpos = 0.1;
                  floorscale = floorscale - 0.074;
                  completeadjusty = -1.485;
                  completeadjustx = 1.97;
                  measureadjust = 1.31;
                }
                if (lengthy2 >= 109 && lengthy2 < 110) {
                  feet1adjust = -1.2;
                  feet2adjust = 0.2;
                  picketadjust = -0.2;
                  botadjust = -1.2;
                  topadjust = -0.15;
                  cornerposy = -0.3;
                  facialadjust1x = -0.3;
                  facialadjust2x = -0.2;
                  floorpos = 0.2;
                  floorscale = floorscale - 0.074;
                  completeadjusty = -1.5;
                  completeadjustx = 1.97;
                  measureadjust = 1.31;
                }
                if (lengthy2 >= 110 && lengthy2 < 111) {
                  feet1adjust = -1.2;
                  feet2adjust = 0.1;
                  picketadjust = 0.8;
                  botadjust = -1.0;
                  topadjust = 0;
                  cornerposy = 0.3;
                  facialadjust1x = 0.3;
                  facialadjust2x = -0;
                  floorpos = 0.3;
                  floorscale = floorscale - 0.074;
                  completeadjusty = -1.5;
                  completeadjustx = 1.97;
                  measureadjust = 1.31;
                }
                if (lengthy2 >= 111 && lengthy2 < 112) {
                  feet1adjust = -1.4;
                  feet2adjust = 0.01;
                  picketadjust = 1.1;
                  botadjust = -1.0;
                  topadjust = 0.1;
                  cornerposy = 0.7;
                  facialadjust1x = 0.8;
                  facialadjust2x = 0.4;
                  floorpos = 0.3;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.51;
                  completeadjustx = 1.97;
                  measureadjust = 1.32;
                }
                if (lengthy2 >= 112 && lengthy2 < 113) {
                  feet1adjust = -1.4;
                  feet2adjust = -0.1;
                  picketadjust = 1.4;
                  botadjust = -0.7;
                  topadjust = 0.2;
                  cornerposy = 1.2;
                  facialadjust1x = 1.3;
                  facialadjust2x = 0.8;
                  floorpos = 0.3;
                  floorscale = floorscale - 0.076;
                  completeadjusty = -1.52;
                  completeadjustx = 1.97;
                  measureadjust = 1.32;
                }
                if (lengthy2 >= 113 && lengthy2 < 114) {
                  feet1adjust = -1.4;
                  feet2adjust = -0.2;
                  picketadjust = 1.6;
                  botadjust = -0.6;
                  topadjust = 0.3;
                  cornerposy = 1.6;
                  facialadjust1x = 1.8;
                  facialadjust2x = 1.2;
                  floorpos = 0.4;
                  floorscale = floorscale - 0.078;
                  completeadjusty = -1.535;
                  completeadjustx = 1.97;
                  measureadjust = 1.32;
                }
                if (lengthy2 >= 114 && lengthy2 < 115) {
                  feet1adjust = -1.6;
                  feet2adjust = -0.25;
                  picketadjust = 1.8;
                  botadjust = -0.5;
                  topadjust = 0.4;
                  cornerposy = 2.1;
                  facialadjust1x = 2.3;
                  facialadjust2x = 1.6;
                  floorpos = 0.5;
                  floorscale = floorscale - 0.078;
                  completeadjusty = -1.545;
                  completeadjustx = 1.97;
                  measureadjust = 1.32;
                }
                if (lengthy2 >= 115 && lengthy2 < 116) {
                  feet1adjust = -1.5;
                  feet2adjust = -0.3;
                  picketadjust = 2.3;
                  botadjust = -0.4;
                  topadjust = 0.5;
                  cornerposy = 2.7;
                  facialadjust1x = 2.9;
                  facialadjust2x = 2;
                  floorpos = 0.5;
                  floorscale = floorscale - 0.082;
                  completeadjusty = -1.56;
                  completeadjustx = 1.97;
                  measureadjust = 1.32;
                }
                if (lengthy2 >= 116 && lengthy2 < 117) {
                  feet1adjust = -1.7;
                  feet2adjust = -0.45;
                  picketadjust = 2.8;
                  botadjust = -0.3;
                  topadjust = 0.6;
                  cornerposy = 3.2;
                  facialadjust1x = 3.3;
                  facialadjust2x = 2.4;
                  floorpos = 0.6;
                  floorscale = floorscale - 0.082;
                  completeadjusty = -1.57;
                  completeadjustx = 1.97;
                  measureadjust = 1.32;
                }
                if (lengthy2 >= 117 && lengthy2 < 118) {
                  feet1adjust = -1.7;
                  feet2adjust = -0.5;
                  picketadjust = 3;
                  botadjust = -0.3;
                  topadjust = 0.6;
                  cornerposy = 3.6;
                  facialadjust1x = 3.8;
                  facialadjust2x = 2.8;
                  floorpos = 0.7;
                  floorscale = floorscale - 0.082;
                  completeadjusty = -1.59;
                  completeadjustx = 1.97;
                  measureadjust = 1.31;
                }
                if (lengthy2 >= 118 && lengthy2 < 119) {
                  feet1adjust = -1.7;
                  feet2adjust = -0.6;
                  picketadjust = 3.3;
                  botadjust = -0.1;
                  topadjust = 0.7;
                  cornerposy = 4;
                  facialadjust1x = 4.3;
                  facialadjust2x = 3.2;
                  floorpos = 0.75;
                  floorscale = floorscale - 0.086;
                  completeadjusty = -1.61;
                  completeadjustx = 1.97;
                  measureadjust = 1.3;
                }
                if (lengthy2 >= 119 && lengthy2 < 120) {
                  feet1adjust = -1.8;
                  feet2adjust = -0.65;
                  picketadjust = 3.7;
                  botadjust = 0;
                  topadjust = 0.8;
                  cornerposy = 4.1;
                  facialadjust1x = 4.9;
                  facialadjust2x = 3.6;
                  floorpos = 0.8;
                  floorscale = floorscale - 0.088;
                  completeadjusty = -1.63;
                  completeadjustx = 1.97;
                  measureadjust = 1.298;
                }
                if (lengthy2 >= 120) {
                  feet1adjust = -1.9;
                  feet2adjust = -0.75;
                  picketadjust = 3.8;
                  botadjust = 0.1;
                  topadjust = 0.9;
                  cornerposy = 4.4;
                  facialadjust1x = 4.5;
                  facialadjust2x = 4;
                  floorpos = 0.8;
                  floorscale = floorscale - 0.09;
                  completeadjusty = -1.64;
                  completeadjustx = 1.97;
                  measureadjust = 1.295;
                  topperadjust = 5.9;
                }
                completeadjustx = 1.97;
                topperadjust = -36 + (41.2 / 70) * divy;

                if (!topmount) {
                  floorscale = floorscale + 0.11;
                }
                if (index == 0) {
                  facialplate1 = true;
                  firstadjust = 0.37;
                  initialcornerr = false;
                  finalcornerr = true;
                }
                if (index > 0 && topmount) {
                  floorscale = floorscale + 0.37 - 0.11;
                  alignadjustscale = 0;
                }
                if (index > 0 && facial) {
                  floorscale = floorscale - 0.037;
                  alignadjustscale = 0;
                }
              }

              let lengthytop = parseInt(props.len3) + 70;
              if (para.count == 'en-us' || para.count == 'es-us') {
                lengthytop = parseFloat(props.len3 / 25.4 + 70 / 25.4).toFixed(2);
              }

              if (pointies3.length <= 2 && topmount) {
                floorscale = (parseInt(lengthy2) - 50) * 0.00897 + 0.33;
                floorpos = floorpos - 3.1;
              }

              if (topmount && pointies3.length > 2) {
                if (index == pointies3.length - 2) {
                  floorscale = floorscale - 0.152;
                }
              }
              return (
                <>
                  <group
                    {...props}
                    dispose={null}
                    scale={[0.1, 0.1, 0.1]}
                    position={[midpoint[0] + completeadjustx, 0, midpoint[1] + completeadjusty]}
                    rotation-y={angle}
                  >
                    <group position={[3.19, 44.74, 8.66]}>
                      <group position={[0.89, 23.76, -35.14 - picketadjust]}>{picketadd(scaler, singlelength3)}</group>
                      <group visible={straighthandlauf} position={[0.86, 74.24, 8.64]}>
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_MOD5950_normal.geometry}
                          position={[0, heightmove, topadjust]}
                          scale={[handscalex, heightscaler, handscaley]}
                          material={materials['physi alu']}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_MOD5950_normal_Corner_R.geometry}
                          visible={finalcornerr}
                          position={[cornerposx, heightmove, -cornerposy]}
                          material={materials['physi alu']}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_MOD5950_normal_Corner_L.geometry}
                          visible={false}
                          position={[cornerposx, heightmove, cornerposy]}
                          material={materials['physi alu']}
                        />
                      </group>
                      <group visible={bevelhandlauf} position={[0.86, 74.24, 8.64]}>
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_bevel.geometry}
                          position={[0, heightmove, 0]}
                          visible={true}
                          scale={[handscalex, heightscaler, handscaley]}
                          material={materials['physi alu']}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_bevel_Corner_L.geometry}
                          visible={false}
                          position={[cornerposx, heightmove, cornerposy]}
                          material={materials['physi alu']}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Handrail_bevel_Corner_R.geometry}
                          visible={true}
                          position={[cornerposx, heightmove, -cornerposy]}
                          material={materials['physi alu']}
                        />
                      </group>
                      <group visible={true} position={[0.86, 75.54, 8.68]} rotation={[0, 1.57, 0]}>
                        {klammerrender(3)}
                        <mesh
                          visible={false}
                          geometry={nodes.Handrail_Connector_normal_R.geometry}
                          material={materials['physi alu']}
                          position={[56.02, 0 + heightmove, 0]}
                        />
                        <mesh
                          visible={false}
                          geometry={nodes.Handrail_Connector_bevel_R.geometry}
                          material={materials['physi alu']}
                          position={[56.02 + topperadjust, 0 + heightmove, 0]}
                        />
                        <mesh
                          visible={false}
                          geometry={nodes.Handrail_Connector_normal_L.geometry}
                          material={materials['physi alu']}
                          position={[-56.02 - topperadjust, 0 + heightmove, 0]}
                        />
                        <mesh
                          visible={false}
                          geometry={nodes.Handrail_Connector_bevel_L.geometry}
                          material={materials['physi alu']}
                          position={[-56.02 - topperadjust, 0 + heightmove, 0]}
                        />
                      </group>
                      <group visible={false} position={[0.61, 75.56, 8.63]}>
                        <mesh
                          geometry={nodes.Handrail_Corner_Connector_normal_R.geometry}
                          material={materials['physi alu']}
                          position={[0, 0, -60.49]}
                          rotation={[-Math.PI, Math.PI / 4, -Math.PI]}
                        />
                        <mesh
                          geometry={nodes.Handrail_Corner_Connector_bevel_R.geometry}
                          material={materials['physi alu']}
                          position={[0, 0, -60.49]}
                          rotation={[-Math.PI, Math.PI / 4, -Math.PI]}
                        />
                        <mesh
                          geometry={nodes.Handrail_Corner_Connector_normal_L.geometry}
                          material={materials['physi alu']}
                          position={[0, 0, 60.49]}
                          rotation={[0, Math.PI / 4, 0]}
                        />
                        <mesh
                          geometry={nodes.Handrail_Corner_Connector_bevel_L.geometry}
                          material={materials['physi alu']}
                          position={[0, 0, 60.49]}
                          rotation={[0, Math.PI / 4, 0]}
                        />
                      </group>
                      <group position={[-4.68, -33.65, 6.16]} visible={topmount} rotation={[0, 1.57, 0]}>
                        <mesh
                          geometry={nodes.Easy_Alu_Feet_Corner_L.geometry}
                          visible={false}
                          material={materials['physi alu']}
                          position={[-56.19 * scaler + feet1adjust, 1.64, 5.62]}
                        />
                        <mesh
                          geometry={nodes.Easy_Alu_Feet_Corner_R.geometry}
                          visible={finalcornerr}
                          material={materials['physi alu']}
                          position={[51.15 * scaler + feet2adjust, 1.64, 5.62]}
                          rotation={[0, 0, -Math.PI]}
                        />
                        <mesh
                          geometry={nodes.Feet_L.geometry}
                          visible={true}
                          material={materials['physi alu']}
                          position={[-56.64 * scaler + feet1adjust, -0.03, 2.19]}
                        />
                        <mesh
                          geometry={nodes.Feet_R.geometry}
                          visible={initialcornerr}
                          material={materials['physi alu']}
                          position={[56.64 * scaler + feet2adjust, 0.03, -2.19]}
                        />
                      </group>
                      <group position={[0.8, -43.86, -45.03]} visible={facial} rotation={[0, -1.57, 0]}>
                        <mesh
                          geometry={nodes.Feet_Fascia_L.geometry}
                          material={materials['physi alu']}
                          position={[107.41 + facialadjust1x, 11.86, -0.01]}
                          rotation={[0, 0, -Math.PI]}
                        />
                        <mesh
                          visible={false}
                          geometry={nodes.Feet_Adapter_Fascia_L.geometry}
                          material={materials['physi alu']}
                          position={[99.21 + facialadjust1x, 5.86, 2.63]}
                          rotation={[Math.PI, -1.57, 0]}
                        />
                        <mesh
                          geometry={nodes.Feet_Fascia_R.geometry}
                          material={materials['physi alu']}
                          position={[0.1 - facialadjust2x, -0.14, -0.08]}
                        />
                        <mesh
                          visible={facialplate1}
                          geometry={nodes.Feet_Adapter_Fascia_R.geometry}
                          material={materials['physi alu']}
                          position={[8.3 - facialadjust2x, 5.86, 2.63]}
                          rotation={[0, 1.57, 0]}
                        />
                      </group>
                      <mesh
                        geometry={nodes.Easy_Alu_frame_down.geometry}
                        material={materials['physi alu']}
                        scale={[1, 1 * scaler, 1]}
                        position={[0.75, -26.49, 9.11 + botadjust]}
                        rotation={[Math.PI / 2, 0, 0]}
                      />
                      <mesh
                        geometry={nodes.Easy_Alu_frame_R.geometry}
                        material={materials['physi alu']}
                        position={[0.77, 21.18 + heightmove / 2, -45.02 * scaler]}
                        scale={[1, heightscaler, 1]}
                      />
                      <mesh
                        geometry={nodes.Easy_Alu_frame_L.geometry}
                        material={materials['physi alu']}
                        position={[0.77, 21.18 + heightmove / 2, 62.39 * scaler]}
                        scale={[1, heightscaler, 1]}
                      />
                      <mesh
                        visible={false}
                        geometry={nodes.Glass.geometry}
                        material={materials['Glass Frosted']}
                        position={[0.65, 23.97, 8.66]}
                      />
                      <mesh
                        visible={topmount}
                        geometry={nodes.Floor_TOP.geometry}
                        material={materials['physi concrete']}
                        scale={[1, 1, floorscale + firstadjust + alignadjustscale]}
                        position={[-3.19 + alignadjust, -39.62, 8.66 + floorpos]}
                      />
                      <mesh
                        visible={facial}
                        geometry={nodes.Floor_Fascia.geometry}
                        material={materials['physi concrete']}
                        scale={[1, 1, floorscale]}
                        position={[-17.84, -38.01, 8.66 + floorpos]}
                      />
                    </group>
                  </group>
                  {topmount && (
                    <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                      <Line
                        points={[
                          [
                            pointies2[pointies2.length - 1][1] + lastadjust + 0.285,
                            -4,
                            pointies3[pointies3.length - 1][1] + measureadjust,
                          ],
                          [pointies2[pointies2.length - 1][1] + lastadjust + 0.285, -4, pointies3[0][1] + 0.25],
                        ]}
                      />
                      <Line
                        points={[
                          [
                            pointies2[pointies2.length - 1][1] + lastadjust + 0.285,
                            -4.5,
                            pointies3[pointies3.length - 1][1] + measureadjust,
                          ],
                          [
                            pointies2[pointies2.length - 1][1] + lastadjust + 0.285,
                            -1.5,
                            pointies3[pointies3.length - 1][1] + measureadjust,
                          ],
                        ]}
                        dashed={false}
                      />
                      {topmount && (
                        <Text
                          color={'black'}
                          position={[
                            pointies2[pointies2.length - 1][1] + lastadjust + 0.285,
                            -5 + textup,
                            (pointies3[0][1] + pointies3[pointies3.length - 1][1]) / 2,
                          ]}
                          rotation-y={props.polarcoord}
                          scale={textscale}
                        >
                          C :{' '}
                          {para.count != ('en-us' || 'es-us')
                            ? props.len3 + ' mm'
                            : parseFloat(props.len3 / 25.4).toFixed(2) + ' "'}
                        </Text>
                      )}
                      {facial && (
                        <Text
                          color={'black'}
                          position={[
                            pointies2[pointies2.length - 1][1] + lastadjust + 0.285,
                            -5 + textup,
                            (pointies3[0][1] + pointies3[pointies3.length - 1][1]) / 2,
                          ]}
                          rotation-y={props.polarcoord}
                          scale={textscale}
                        >
                          C : {para.count == 'en-us' || para.count == 'es-us' ? lengthytop + ' "' : lengthytop + ' mm'}
                        </Text>
                      )}

                      <Cone
                        position={[
                          pointies2[pointies2.length - 1][1] + lastadjust + 0.285,
                          -4,
                          pointies3[pointies3.length - 1][1] + measureadjust - 0.198,
                        ]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-y={-Math.PI / 2}
                        rotation-z={-Math.PI / 2}
                      />
                      <Cone
                        position={[
                          pointies2[pointies2.length - 1][1] + lastadjust + 0.285,
                          -4,
                          pointies3[0][1] + 0.25 + 0.199,
                        ]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-z={Math.PI / 2}
                        rotation-y={-Math.PI / 2}
                      />
                    </group>
                  )}

                  {facial && (
                    <group position={[groupadjustx, 0, groupadjusty]} visible={true}>
                      <Line
                        points={[
                          [
                            pointies2[pointies2.length - 1][1] + lastadjust + 0.285 - 0.72,
                            -5,
                            pointies3[pointies3.length - 1][1] + measureadjust,
                          ],
                          [
                            pointies2[pointies2.length - 1][1] + lastadjust + 0.285 - 0.72,
                            -5,
                            pointies3[0][1] + 0.25 + 0.72,
                          ],
                        ]}
                      />
                      <Line
                        points={[
                          [
                            pointies2[pointies2.length - 1][1] + lastadjust + 0.285 - 0.72,
                            -0.5,
                            pointies3[pointies3.length - 1][1] + measureadjust,
                          ],
                          [
                            pointies2[pointies2.length - 1][1] + lastadjust + 0.285 - 0.72,
                            -5.5,
                            pointies3[pointies3.length - 1][1] + measureadjust,
                          ],
                        ]}
                        dashed={false}
                      />

                      <Text
                        color={'black'}
                        position={[
                          pointies2[pointies2.length - 1][1] + lastadjust + 0.285 - 0.72,
                          -6 - textup - 1,
                          (pointies3[0][1] + pointies3[pointies3.length - 1][1]) / 2,
                        ]}
                        rotation-y={props.polarcoord}
                        scale={textscale}
                      >
                        C :{' '}
                        {para.count != ('en-us' || 'es-us')
                          ? props.len3 + ' mm'
                          : parseFloat(props.len3 / 25.4).toFixed(2) + ' "'}
                      </Text>

                      <Cone
                        position={[
                          pointies2[pointies2.length - 1][1] + lastadjust + 0.285 - 0.72,
                          -5,
                          pointies3[pointies3.length - 1][1] + measureadjust - 0.198,
                        ]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-y={-Math.PI / 2}
                        rotation-z={-Math.PI / 2}
                      />
                      <Cone
                        position={[
                          pointies2[pointies2.length - 1][1] + lastadjust + 0.285 - 0.72,
                          -5,
                          pointies3[0][1] + 0.25 + 0.199 + 0.72,
                        ]}
                        scale={[0.1, 0.4, 0.1]}
                        material-color={'black'}
                        rotation-z={Math.PI / 2}
                        rotation-y={-Math.PI / 2}
                      />
                    </group>
                  )}

                  {props.wall2 && wallrender(measureadjust, 2, lastadjust)}
                </>
              );
            }
          })}
      </group>
    </>
  );
}

export default EasyAlu;
